<div class="layout-wrapper layout-content-navbar">
  <div class="layout-container">
    <app-side-nav></app-side-nav>

    <div class="layout-page">
      <div class="container mt-4">
        <div class="card">
          <div class="card-body">
            <div [formGroup]="multiForm" class="form-container bg-footer-theme p-3">
              <!-- Dropdown to Select Option -->

              <div>
                <button type="button" class="btn btn" (click)="goBack()" style="color: blue;" >
                    <img src="assets/img/icons/back.png" alt="Back" style="width: 16px; height: 16px; margin-right: 5px; color: blue;"> Back
                </button>
            </div>


              <div class="row mb-3">

                <label for="optionSelect" class="col-sm-2 col-form-label">Select Option:</label>
                <div class="col-sm-3">
                  <select id="optionSelect" formControlName="selectedOption" class="form-select">
                    <option *ngFor="let siteActivity of siteActivitesList" [value]="siteActivity.id">
                      {{ siteActivity.name }}
                    </option>
                  </select>
                </div>
              </div>

              <!-- Form 1: Personal Details -->
              <!-- Form 1: CDA -->
              <div *ngIf="currentFormIndex == 1" formGroupName="CDA">
                <h5>CDA(CONFIDENTIAL DISCLOSURE AGREEMENT)</h5>
                <div formGroupName="3">
                  <!-- Status Dropdown -->
                  <div class="row mb-3">
                    <label for="status" class="col-sm-2 col-form-label">Status</label>
                    <div class="col-sm-3">
                      <select id="status" formControlName="status" class="form-select">
                        <option value="">Select Status</option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                        <option value="NA">NA</option>
                        <option value="Comment">Others</option>
                      </select>
                      <div *ngIf="multiForm.get('CDA.3.status').invalid && multiForm.get('CDA.3.status').touched"
                        class="text-danger">
                        Status is required.
                      </div>
                    </div>
                  </div>

                  <!-- Comment Field (shown only if status is Comment) -->
                  <div class="row mb-3" *ngIf="multiForm.get('CDA.3.status').value === 'Comment'">
                    <label for="comment" class="col-sm-2 col-form-label">Reason</label>
                    <div class="col-sm-3">
                      <textarea id="comment" formControlName="comment" type="text" class="form-control" ></textarea>
                      <div *ngIf="multiForm.get('CDA.3.comment').invalid && multiForm.get('CDA.3.comment').touched"
                        class="text-danger">
                        Please enter a valid comment.
                      </div>
                    </div>
                  </div>

                  <!-- Reason Dropdown (shown only if status is No) -->
                  <div class="row mb-3" *ngIf="multiForm.get('CDA.3.status').value === 'No'">
                    <label for="reason" class="col-sm-2 col-form-label">Reason</label>
                    <div class="col-sm-3">
                      <select id="reason" formControlName="reason" class="form-select">
                        <option value="">Select Reason</option>
                        <option value="Please not available">PI not available</option>
                        <option value="Please has a query regarding CDA">PI has a query regarding CDA</option>
                        <option value="Please did not agree with the terms of CDA">PI did not agree with the terms
                          of CDA</option>
                        <option value="Other">Other</option>
                      </select>
                      <div *ngIf="multiForm.get('CDA.3.reason').invalid && multiForm.get('CDA.3.reason').touched"
                        class="text-danger">
                        Reason is required when status is No.
                      </div>
                    </div>
                  </div>
                  <!-- CDA Document Link Field -->
                  <div class="row mb-3">
                    <label for="cdaDocument" class="col-sm-2 col-form-label">CDA Document Link</label>
                    <div class="col-sm-3">
                      <!--<a *ngIf="cdaDocumentLink && cdaDocumentLink !== 'not_available'" [href]="cdaDocumentLink" target="_blank" class="link-primary mt-1">
                        {{ cdaDocumentLink }}
                      </a>-->
                      <a *ngIf="cdaDocumentLink && cdaDocumentLink !== 'not_available'" [href]="cdaDocumentLink" target="_blank" class="link-primary mt-1">
                        Click here
                      </a>
                    </div>
                  </div>


                  <!-- Signature Field -->
                  <div class="row mb-3">
                    <label for="signature" class="col-sm-2 col-form-label">Signature</label>
                    <div class="col-sm-3">
                      <input id="signature" formControlName="input" type="text" class="form-control" />
                      <div *ngIf="multiForm.get('CDA.3.input').invalid && multiForm.get('CDA.3.input').touched"
                        class="text-danger">
                        Please enter a valid signature.
                      </div>
                    </div>
                  </div>

                  <!-- Next Button -->
                  <div class="row">
                    <div class="col-sm-3 offset-sm-2">
                      <button type="button" class="btn btn-primary" (click)="onSubmit()">Submit</button>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="currentFormIndex == 2" formGroupName="Site_Feasibility">
                <h5>Site Feasibility</h5>
                <div formGroupName="4">
                  <!-- Status Dropdown -->
                  <div class="row mb-3">
                    <label for="status" class="col-sm-2 col-form-label">Status</label>
                    <div class="col-sm-3">
                      <select id="status" formControlName="status" class="form-select">
                        <option value="">Select Status</option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                        <option value="NA">NA</option>
                        <option value="Comment">Others</option>
                      </select>
                      <div
                        *ngIf="multiForm.get('Site_Feasibility.4.status').invalid && multiForm.get('Site_Feasibility.4.status').touched"
                        class="text-danger">
                        Status is required.
                      </div>
                    </div>
                  </div>

                  <!-- Comment Field (shown only if status is Comment) -->
                  <div class="row mb-3" *ngIf="multiForm.get('Site_Feasibility.4.status').value === 'Comment'">
                    <label for="comment" class="col-sm-2 col-form-label">Reason</label>
                    <div class="col-sm-3">
                      <textarea id="comment" formControlName="comment" type="text" class="form-control" ></textarea>
                      <div
                        *ngIf="multiForm.get('Site_Feasibility.4.comment').invalid && multiForm.get('Site_Feasibility.4.comment').touched"
                        class="text-danger">
                        Please enter a valid comment.
                      </div>
                    </div>
                  </div>

                  <!-- Reason Dropdown (shown only if status is No) -->
                  <div class="row mb-3" *ngIf="multiForm.get('Site_Feasibility.4.status').value === 'No'">
                    <label for="reason" class="col-sm-2 col-form-label">Reason</label>
                    <div class="col-sm-3">
                      <select id="reason" formControlName="reason" class="form-select">
                        <option value="">Select Reason</option>
                        <option value="Site not feasibile">Site not feasibile</option>
                        <!-- <option value="not enough patient pool for this study">not enough patient pool for this study -->
                          <option value="Not enough patient pool for this study">Not enough patient pool for this study
                        </option>
                        <option value="PI not interested in the study">PI not interested in the study</option>
                        <option value="Other">Other</option>
                      </select>
                      <div
                        *ngIf="multiForm.get('Site_Feasibility.4.reason').invalid && multiForm.get('Site_Feasibility.4.reason').touched"
                        class="text-danger">
                        Reason is required when status is No.
                      </div>
                    </div>
                  </div>

                  <!-- Signature Field -->
                  <div class="row mb-3">
                    <label for="signature" class="col-sm-2 col-form-label">Site Feasibility Link</label>
                    <div class="col-sm-3">
                      <input id="signature" formControlName="input" type="text" class="form-control" />
                      <div
                        *ngIf="multiForm.get('Site_Feasibility.4.input').invalid && multiForm.get('Site_Feasibility.4.input').touched"
                        class="text-danger">
                        Please enter a valid Link.
                      </div>
                      <a 
                        *ngIf="multiForm.get('Site_Feasibility.4.input').value" 
                        [href]="multiForm.get('Site_Feasibility.4.input').value" 
                        target="_blank"
                        class="btn btn-link mt-2">
                        Click here
                      </a>
                    </div>
                  </div>

                  <!-- Next Button -->
                  <div class="row">
                    <div class="col-sm-3 offset-sm-2">
                      <button type="button" class="btn btn-primary" (click)="onSubmit()">Submit</button>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="currentFormIndex == 5" formGroupName="CTA">
                <div formGroupName="6">
                  <h5>CTA/MOU</h5>
                  <!-- Status Dropdown -->
                  <div class="row mb-3">
                    <label for="status" class="col-sm-2 col-form-label">Status</label>
                    <div class="col-sm-3">
                      <select id="status" formControlName="status" class="form-select">
                        <option value="">Select Status</option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                        <option value="NA">NA</option>
                        <option value="Comment">Others</option>
                      </select>
                      <div *ngIf="multiForm.get('CTA.6.status').invalid && multiForm.get('CTA.6.status').touched"
                        class="text-danger">
                        Status is required.
                      </div>
                    </div>
                  </div>

                  <!-- Comment Field (shown only if status is Comment) -->
                  <div class="row mb-3" *ngIf="multiForm.get('CTA.6.status').value === 'Comment'">
                    <label for="comment" class="col-sm-2 col-form-label">Reason</label>
                    <div class="col-sm-3">
                      <textarea id="comment" formControlName="comment" type="text" class="form-control" ></textarea>
                      <div *ngIf="multiForm.get('CTA.6.comment').invalid && multiForm.get('CTA.6.comment').touched"
                        class="text-danger">
                        Please enter a valid comment.
                      </div>
                    </div>
                  </div>

                  <!-- Reason Dropdown (shown only if status is No) -->
                  <!-- <div class="row mb-3" *ngIf="multiForm.get('CTA.6.status').value === 'No'">
                    <label for="reason" class="col-sm-2 col-form-label">Reason</label>
                    <div class="col-sm-3">
                      <select id="reason" formControlName="reason" class="form-select">
                        <option value="">Select Reason</option>
                      </select>
                      <div
                        *ngIf="multiForm.get('CTA.6.reason').invalid && multiForm.get('CTA.6.reason').touched"
                        class="text-danger">
                        Reason is required when status is No.
                      </div>
                    </div>
                  </div> -->

                  <!-- Signature Field -->
                  <div class="row mb-3" *ngIf="multiForm.get('CTA.6.status').value === 'No'">
                    <label for="signature" class="col-sm-2 col-form-label">CTA Link</label>
                    <div class="col-sm-3">
                      <input id="signature" formControlName="input" type="text" class="form-control" />
                      <div *ngIf="multiForm.get('CTA.6.input').invalid && multiForm.get('CTA.6.input').touched"
                        class="text-danger">
                        Please enter a valid Link.
                      </div>
                      <a *ngIf="multiForm.get('CTA.6.input').value" 
                        [href]="multiForm.get('CTA.6.input').value" 
                        target="_blank" 
                        class="btn btn-link">
                        Click here
                      </a>
                    </div>
                  </div>
                </div>
                <div formGroupName="7">
                  <!-- Status Dropdown -->
                  <h5>SYNOPSIS</h5>
                  <div class="row mb-3">
                    <label for="status" class="col-sm-2 col-form-label">Status</label>
                    <div class="col-sm-3">
                      <select id="status" formControlName="status" class="form-select">
                        <option value="">Select Status</option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                        <option value="NA">NA</option>
                        <option value="Comment">Others</option>
                      </select>
                      <div
                        *ngIf="multiForm.get('DOCUMENT_SUBMISSION_TO_PI.46.status').invalid && multiForm.get('CTA.7.status').touched"
                        class="text-danger">
                        Status is required.
                      </div>
                    </div>
                  </div>

                  <!-- Comment Field (shown only if status is Comment) -->
                  <div class="row mb-3" *ngIf="multiForm.get('CTA.7.status').value === 'Comment'">
                    <label for="comment" class="col-sm-2 col-form-label">Reason</label>
                    <div class="col-sm-3">
                      <textarea id="comment" formControlName="comment" type="text" class="form-control" ></textarea>
                      <div *ngIf="multiForm.get('CTA.7.comment').invalid && multiForm.get('CTA.7.comment').touched"
                        class="text-danger">
                        Please enter a valid comment.
                      </div>
                    </div>
                  </div>

                  <!-- Reason Dropdown (shown only if status is No) -->
                  <!-- <div class="row mb-3" *ngIf="multiForm.get('CTA.7.status').value === 'No'">
                    <label for="reason" class="col-sm-2 col-form-label">Reason</label>
                    <div class="col-sm-3">
                      <select id="reason" formControlName="reason" class="form-select">
                        <option value="">Select Reason</option>
                      </select>
                      <div
                        *ngIf="multiForm.get('CTA.7.reason').invalid && multiForm.get('CTA.7.reason').touched"
                        class="text-danger">
                        Reason is required when status is No.
                      </div>
                    </div>
                  </div> -->

                  <!-- Signature Field -->
                  <div class="row mb-3" *ngIf="multiForm.get('CTA.7.status').value === 'No'">
                    <label for="signature" class="col-sm-2 col-form-label">Input</label>
                    <div class="col-sm-3">
                      <input id="signature" formControlName="input" type="text" class="form-control" />
                      <div *ngIf="multiForm.get('CTA.7.input').invalid && multiForm.get('CTA.7.input').touched"
                        class="text-danger">
                        Please enter a valid Link.
                      </div>
                    </div>
                  </div>
                </div>
                <div formGroupName="8">
                  <!-- Status Dropdown -->
                  <h5>BUDGET</h5>
                  <div class="row mb-3">
                    <label for="status" class="col-sm-2 col-form-label">Status</label>
                    <div class="col-sm-3">
                      <select id="status" formControlName="status" class="form-select">
                        <option value="">Select Status</option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                        <option value="NA">NA</option>
                        <option value="Comment">Others</option>
                      </select>
                      <div *ngIf="multiForm.get('CTA.8.status').invalid && multiForm.get('CTA.8.status').touched"
                        class="text-danger">
                        Status is required.
                      </div>
                    </div>
                  </div>

                  <!-- Comment Field (shown only if status is Comment) -->
                  <div class="row mb-3" *ngIf="multiForm.get('CTA.8.status').value === 'Comment'">
                    <label for="comment" class="col-sm-2 col-form-label">Reason</label>
                    <div class="col-sm-3">
                      <textarea id="comment" formControlName="comment" type="text" class="form-control" ></textarea>
                      <div *ngIf="multiForm.get('CTA.8.comment').invalid && multiForm.get('CTA.8.comment').touched"
                        class="text-danger">
                        Please enter a valid comment.
                      </div>
                    </div>
                  </div>

                  <!-- Reason Dropdown (shown only if status is No) -->
                  <!-- <div class="row mb-3" *ngIf="multiForm.get('CTA.8.status').value === 'No'">
                    <label for="reason" class="col-sm-2 col-form-label">Reason</label>
                    <div class="col-sm-3">
                      <select id="reason" formControlName="reason" class="form-select">
                        <option value="">Select Reason</option>
                      </select>
                      <div
                        *ngIf="multiForm.get('CTA.8.reason').invalid && multiForm.get('CTA.8.reason').touched"
                        class="text-danger">
                        Reason is required when status is No.
                      </div>
                    </div>
                  </div> -->

                  <!-- Signature Field -->
                  <div class="row mb-3" *ngIf="multiForm.get('CTA.8.status').value === 'No'">
                    <label for="signature" class="col-sm-2 col-form-label">input</label>
                    <div class="col-sm-3">
                      <input id="signature" formControlName="input" type="text" class="form-control" />
                      <div *ngIf="multiForm.get('CTA.8.input').invalid && multiForm.get('CTA.8.input').touched"
                        class="text-danger">
                        Please enter a valid Link.
                      </div>
                    </div>
                  </div>
                </div>


                <!-- Next Button -->
                <div class="row">
                  <div class="col-sm-3 offset-sm-2">
                    <button type="button" class="btn btn-primary" (click)="onSubmit()">Submit</button>
                  </div>
                </div>
              </div>
              <div *ngIf="currentFormIndex == 9" formGroupName="DOCUMENT_SUBMISSION_TO_PI">
                <div formGroupName="10">
                  <h5>TMF DOCUMENTS</h5>
                  <!-- Status Dropdown -->
                  <div class="row mb-3">
                    <label for="status" class="col-sm-2 col-form-label">Status</label>
                    <div class="col-sm-3">
                      <select id="status" formControlName="status" class="form-select">
                        <option value="">Select Status</option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                        <option value="NA">NA</option>
                        <option value="Comment">Others</option>
                      </select>
                      <div
                        *ngIf="multiForm.get('DOCUMENT_SUBMISSION_TO_PI.10.status').invalid && multiForm.get('DOCUMENT_SUBMISSION_TO_PI.10.status').touched"
                        class="text-danger">
                        Status is required.
                      </div>
                    </div>
                  </div>

                  <!-- Comment Field (shown only if status is Comment) -->
                  <div class="row mb-3"
                    *ngIf="multiForm.get('DOCUMENT_SUBMISSION_TO_PI.10.status').value === 'Comment'">
                    <label for="comment" class="col-sm-2 col-form-label">Reason</label>
                    <div class="col-sm-3">
                      <textarea id="comment" formControlName="comment" type="text" class="form-control" ></textarea>
                      <div
                        *ngIf="multiForm.get('DOCUMENT_SUBMISSION_TO_PI.10.comment').invalid && multiForm.get('DOCUMENT_SUBMISSION_TO_PI.10.comment').touched"
                        class="text-danger">
                        Please enter a valid comment.
                      </div>
                    </div>
                  </div>

                  <!-- Reason Dropdown (shown only if status is No) -->
                  <div class="row mb-3" *ngIf="multiForm.get('DOCUMENT_SUBMISSION_TO_PI.10.status').value === 'No'">
                    <label for="reason" class="col-sm-2 col-form-label">Reason</label>
                    <div class="col-sm-3">
                      <select id="reason" formControlName="reason" class="form-select">
                        <option value="">Select Reason</option>

                        <option value="Site did not receive the document">Site did not receive the document</option>
                        <option value="Delayed courier service">Delayed courier service</option>
                        <option value="Incomplete set of document received">Incomplete set of document received</option>
                        <option value="Responsible person was not available on the site">Responsible person was not
                          available on the site</option>
                        <option value="Due to a holiday site did not collect the documents">Due to a holiday site did
                          not collect the documents</option>
                        <option value="Other">Other</option>
                      </select>
                      <div
                        *ngIf="multiForm.get('DOCUMENT_SUBMISSION_TO_PI.10.reason').invalid && multiForm.get('DOCUMENT_SUBMISSION_TO_PI.10.reason').touched"
                        class="text-danger">
                        Reason is required when status is No.
                      </div>
                    </div>
                  </div>
                </div>
                <div formGroupName="46">
                  <!-- Status Dropdown -->
                  <h5>Any documents missing in TMF</h5>
                  <div class="row mb-3">
                    <label for="status" class="col-sm-2 col-form-label">Status</label>
                    <div class="col-sm-3">
                      <select id="status" formControlName="status" class="form-select">
                        <option value="">Select Status</option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                        <option value="NA">NA</option>
                        <option value="Comment">Others</option>
                      </select>
                      <div
                        *ngIf="multiForm.get('DOCUMENT_SUBMISSION_TO_PI.46.status').invalid && multiForm.get('DOCUMENT_SUBMISSION_TO_PI.46.status').touched"
                        class="text-danger">
                        Status is required.
                      </div>
                    </div>
                  </div>

                  <!-- Comment Field (shown only if status is Comment) -->
                  <div class="row mb-3"
                    *ngIf="multiForm.get('DOCUMENT_SUBMISSION_TO_PI.46.status').value === 'Comment'">
                    <label for="comment" class="col-sm-2 col-form-label">Reason</label>
                    <div class="col-sm-3">
                      <textarea id="comment" formControlName="comment" type="text" class="form-control" ></textarea>
                      <div
                        *ngIf="multiForm.get('DOCUMENT_SUBMISSION_TO_PI.46.comment').invalid && multiForm.get('DOCUMENT_SUBMISSION_TO_PI.46.comment').touched"
                        class="text-danger">
                        Please enter a valid comment.
                      </div>
                    </div>
                  </div>

                  <!-- Reason Dropdown (shown only if status is No) -->
                  <div class="row mb-3" *ngIf="multiForm.get('DOCUMENT_SUBMISSION_TO_PI.46.status').value === 'Yes'">
                    <label for="reason" class="col-sm-2 col-form-label">Reason</label>
                    <div class="col-sm-4">

                      <ng-multiselect-dropdown formControlName="reason"
                        [settings]="dropdownSettings" [data]="missingDocuments" placeholder="Select Missing Documents">
                      </ng-multiselect-dropdown>
                      <!--  <select id="reason" formControlName="reason" class="form-select" multiple>
                        <option value="">Select Reason</option>

                        <option value="CTA">CTA</option>
                        <option value="Confidentiality Disclosure Agreement">Confidentiality Disclosure Agreement
                        </option>
                        <option value="Investigator Undertaking">Investigator Undertaking</option>
                        <option value="GMP Certificate">GMP Certificate</option>
                        <option value="CRO Agreement">CRO Agreement</option>
                        <option value="Central Laboratory Agreement">Central Laboratory Agreement</option>
                        <option value="Budget">Budget</option>
                        <option value="Insurance Certificate">Insurance Certificate</option>
                        <option value="Protocol">Protocol</option>
                        <option value="Investigator Brochure">Investigator Brochure</option>
                        <option value="Submission letter">Submission letter</option>
                        <option value="Approval letter">Approval letter</option>
                        <option value="Amendment">Amendment</option>
                        <option value="Communication">Communication</option>
                        <option value="Queries">Queries</option>
                        <option value="Correspondence Amendment">Correspondence Amendment</option>
                        <option value="FDA approval">FDA approval</option>
                        <option value="CTRI Registration">CTRI Registration</option>
                        <option value="Certificate of Analysis">Certificate of Analysis</option>
                        <option value="Informed Consent Form (Approved) (Original and Translation Certificate)">Informed
                          Consent Form (Approved) (Original and Translation Certificate)</option>
                        <option value="Sponsor contact log">Sponsor contact log</option>
                        <option value="CRO contact log">CRO contact log</option>
                        <option value="Site contact log">Site contact log</option>
                        <option value="Lab Personnel contact log">Lab Personnel contact log</option>
                        <option value="IEC contact log">IEC contact log</option>
                        <option value="Delegation Log (Site-wise)">Delegation Log (Site-wise)</option>
                        <option value="Site Staff CVs">Site Staff CVs</option>
                        <option value="MRC">MRC</option>
                        <option value="Feasibility visit">Feasibility visit</option>
                        <option value="Initiation visit">Initiation visit</option>
                        <option value="Staff training log">Staff training log</option>
                        <option value="Monitoring visit log">Monitoring visit log</option>
                        <option value="Reports">Reports</option>
                        <option value="Screening log">Screening log</option>
                        <option value="Enrollment log">Enrollment log</option>
                        <option value="Scheduled activity log">Scheduled activity log</option>
                        <option value="Dropout log">Dropout log</option>
                        <option value="Withdraw log">Withdraw log</option>
                        <option value="Source">Source</option>
                        <option value="Appendix">Appendix</option>
                        <option value="AE (Adverse Event) log">AE (Adverse Event) log</option>
                        <option value="SAE (Serious Adverse Event)">SAE (Serious Adverse Event)</option>
                        <option value="Deviation/Violation Log">Deviation/Violation Log</option>
                        <option value="Shipment records">Shipment records</option>
                        <option value="Return records">Return records</option>
                        <option value="Accountability log">Accountability log</option>
                        <option value="Disposition">Disposition</option>
                        <option value="Shipment">Shipment</option>
                        <option value="Return/Disposition records">Return/Disposition records</option>
                        <option value="Accountability log">Accountability log</option>
                        <option value="Reference Range for Lab Investigations">Reference Range for Lab Investigations
                        </option>
                        <option value="Randomization List">Randomization List</option>
                        <option value="Status Reports">Status Reports</option>
                        <option value="Correspondence/Communication Records">Correspondence/Communication Records
                        </option>
                        <option value="Clinical Study Report">Clinical Study Report</option>
                        <option value="Close out report">Close out report</option>
                      </select> -->
                      <div
                        *ngIf="multiForm.get('DOCUMENT_SUBMISSION_TO_PI.46.reason').invalid && multiForm.get('DOCUMENT_SUBMISSION_TO_PI.46.reason').touched"
                        class="text-danger">
                        Reason is required when status is No.
                      </div>
                    </div>
                  </div>

                  <!-- Signature Field -->
                  <!-- <div class="row mb-3" *ngIf="multiForm.get('DOCUMENT_SUBMISSION_TO_PI.46.status').value === 'No'">
                    <label for="signature" class="col-sm-2 col-form-label">Input</label>
                    <div class="col-sm-3">
                      <input id="signature" formControlName="input" type="text" class="form-control" />
                      <div
                        *ngIf="multiForm.get('DOCUMENT_SUBMISSION_TO_PI.46.input').invalid && multiForm.get('DOCUMENT_SUBMISSION_TO_PI.46.input').touched"
                        class="text-danger">
                        Please enter a valid Link.
                      </div>
                    </div>
                  </div> -->
                </div>
                <div formGroupName="81">
                  <!-- Status Dropdown -->
                  <h5>Insurance/indemnity letter</h5>
                  <div class="row mb-3">
                    <label for="status" class="col-sm-2 col-form-label">Status</label>
                    <div class="col-sm-3">
                      <select id="status" formControlName="status" class="form-select">
                        <option value="">Select Status</option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                        <option value="NA">NA</option>
                        <option value="Comment">Others</option>
                      </select>
                      <div
                        *ngIf="multiForm.get('DOCUMENT_SUBMISSION_TO_PI.81.status').invalid && multiForm.get('DOCUMENT_SUBMISSION_TO_PI.81.status').touched"
                        class="text-danger">
                        Status is required.
                      </div>
                    </div>
                  </div>

                  <!-- Comment Field (shown only if status is Comment) -->
                  <div class="row mb-3"
                    *ngIf="multiForm.get('DOCUMENT_SUBMISSION_TO_PI.81.status').value === 'Comment'">
                    <label for="comment" class="col-sm-2 col-form-label">Reason</label>
                    <div class="col-sm-3">
                      <textarea id="comment" formControlName="comment" type="text" class="form-control" ></textarea>
                      <div
                        *ngIf="multiForm.get('DOCUMENT_SUBMISSION_TO_PI.81.comment').invalid && multiForm.get('DOCUMENT_SUBMISSION_TO_PI.81.comment').touched"
                        class="text-danger">
                        Please enter a valid comment.
                      </div>
                    </div>
                  </div>

                  <!-- Reason Dropdown (shown only if status is No) -->
                  <div class="row mb-3" *ngIf="multiForm.get('DOCUMENT_SUBMISSION_TO_PI.81.status').value === 'No'">
                    <label for="reason" class="col-sm-2 col-form-label">Reason</label>
                    <div class="col-sm-3">
                      <select id="reason" formControlName="reason" class="form-select">
                        <option value="">Select Reason</option>

                        <option value="Application in process">Application in process</option>
                        <option value="insurance not finalized by sponsor">Insurance not finalized by sponsor</option>
                        <option value="insurance certificate pending">Insurance certificate pending</option>
                        <option value="Other">Other</option>
                      </select>
                      <div
                        *ngIf="multiForm.get('DOCUMENT_SUBMISSION_TO_PI.81.reason').invalid && multiForm.get('DOCUMENT_SUBMISSION_TO_PI.81.reason').touched"
                        class="text-danger">
                        Reason is required when status is No.
                      </div>
                    </div>
                  </div>
                  <!-- Next Button -->
                  <div class="row">
                    <div class="col-sm-3 offset-sm-2">
                      <button type="button" class="btn btn-primary" (click)="onSubmit()">Submit</button>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="currentFormIndex == 13" formGroupName="EC_Submission">
                <div formGroupName="21">
                  <h5>EC SUBMISSION</h5>
                  <!-- Status Dropdown -->
                  <div class="row mb-3">
                    <label for="status" class="col-sm-2 col-form-label">Status</label>
                    <div class="col-sm-3">
                      <select id="status" formControlName="status" class="form-select">
                        <option value="">Select Status</option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                        <option value="NA">NA</option>
                        <option value="Comment">Others</option>
                      </select>
                      <div
                        *ngIf="multiForm.get('EC_Submission.21.status').invalid && multiForm.get('EC_Submission.21.status').touched"
                        class="text-danger">
                        Status is required.
                      </div>
                    </div>
                  </div>

                  <!-- Comment Field (shown only if status is Comment) -->
                  <div class="row mb-3" *ngIf="multiForm.get('EC_Submission.21.status').value === 'Comment'">
                    <label for="comment" class="col-sm-2 col-form-label">Reason</label>
                    <div class="col-sm-3">
                      <textarea id="comment" formControlName="comment" type="text" class="form-control" ></textarea>
                      <div
                        *ngIf="multiForm.get('EC_Submission.21.comment').invalid && multiForm.get('EC_Submission.21.comment').touched"
                        class="text-danger">
                        Please enter a valid comment.
                      </div>
                    </div>
                  </div>

                  <!-- Reason Dropdown (shown only if status is No) -->
                  <div class="row mb-3" *ngIf="multiForm.get('EC_Submission.21.status').value === 'No'">
                    <label for="reason" class="col-sm-2 col-form-label">Reason</label>
                    <div class="col-sm-3">
                      <select id="reason" formControlName="reason" class="form-select">
                        <option value="">Select Reason</option>
                        <option value="EC Meeting not scheduled ">EC Meeting not scheduled</option>
                        <option value="PI /CO-I not available to submit document to IEC ">PI /CO-I not available to
                          submit document to IEC</option>
                        <option value="Incomplete set of documents (any Documents missing/Remain to sent)"> Incomplete
                          set of documents (any Documents missing/Remain to sent)</option>
                        <option value="Other">Other</option>
                      </select>
                      <div
                        *ngIf="multiForm.get('EC_Submission.21.reason').invalid && multiForm.get('EC_Submission.21.reason').touched"
                        class="text-danger">
                        Reason is required when status is No.
                      </div>
                    </div>
                  </div>

                  <!-- Signature Field -->
                  <!-- <div class="row mb-3" *ngIf="multiForm.get('EC_Submission.21.status').value === 'No'">
                    <label for="signature" class="col-sm-2 col-form-label">Google Link</label>
                    <div class="col-sm-3">
                      <input id="signature" formControlName="input" type="text" class="form-control" />
                      <div *ngIf="multiForm.get('EC_Submission.21.input').invalid && multiForm.get('EC_Submission.21.input').touched"
                        class="text-danger">
                        Please enter a valid Link.
                      </div>
                    </div>
                  </div> -->
                </div>
                <div formGroupName="22">
                  <!-- Status Dropdown -->
                  <h5>EC FEES SUBMITTED</h5>
                  <div class="row mb-3">
                    <label for="status" class="col-sm-2 col-form-label">Status</label>
                    <div class="col-sm-3">
                      <select id="status" formControlName="status" class="form-select">
                        <option value="">Select Status</option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                        <option value="NA">NA</option>
                        <option value="Comment">Others</option>
                      </select>
                      <div
                        *ngIf="multiForm.get('EC_Submission.22.status').invalid && multiForm.get('EC_Submission.22.status').touched"
                        class="text-danger">
                        Status is required.
                      </div>
                    </div>
                  </div>

                  <!-- Comment Field (shown only if status is Comment) -->
                  <div class="row mb-3" *ngIf="multiForm.get('EC_Submission.22.status').value === 'Comment'">
                    <label for="comment" class="col-sm-2 col-form-label">Reason</label>
                    <div class="col-sm-3">
                      <textarea id="comment" formControlName="comment" type="text" class="form-control" ></textarea>
                      <div
                        *ngIf="multiForm.get('EC_Submission.22.comment').invalid && multiForm.get('EC_Submission.22.comment').touched"
                        class="text-danger">
                        Please enter a valid comment.
                      </div>
                    </div>
                  </div>

                  <!-- Reason Dropdown (shown only if status is No) -->
                  <!-- <div class="row mb-3" *ngIf="multiForm.get('EC_Submission.22.status').value === 'No'">
                    <label for="reason" class="col-sm-2 col-form-label">Reason</label>
                    <div class="col-sm-3">
                      <select id="reason" formControlName="reason" class="form-select">
                        <option value="">Select Reason</option>
                      </select>
                      <div
                        *ngIf="multiForm.get('EC_Submission.22.reason').invalid && multiForm.get('EC_Submission.22.reason').touched"
                        class="text-danger">
                        Reason is required when status is No.
                      </div>
                    </div>
                  </div> -->

                  <!-- Signature Field -->
                  <div class="row mb-3" *ngIf="multiForm.get('EC_Submission.22.status').value === 'No'">
                    <label for="signature" class="col-sm-2 col-form-label">Input</label>
                    <div class="col-sm-3">
                      <input id="signature" formControlName="input" type="text" class="form-control" />
                      <div
                        *ngIf="multiForm.get('EC_Submission.22.input').invalid && multiForm.get('EC_Submission.22.input').touched"
                        class="text-danger">
                        Please enter a valid Link.
                      </div>
                    </div>
                  </div>
                </div>
                <div formGroupName="23">
                  <!-- Status Dropdown -->
                  <h5>EC RESPONSE</h5>
                  <div class="row mb-3">
                    <label for="status" class="col-sm-2 col-form-label">Status</label>
                    <div class="col-sm-3">
                      <select id="status" formControlName="status" class="form-select">
                        <option value="">Select Status</option>
                        <option value="Approved">Approved</option>
                        <option value="Rejected">Rejected</option>
                        <option value="Queries raised">Queries raised</option>
                      </select>
                      <div
                        *ngIf="multiForm.get('EC_Submission.23.status').invalid && multiForm.get('EC_Submission.23.status').touched"
                        class="text-danger">
                        Status is required.
                      </div>
                    </div>
                  </div>

                  <!-- Comment Field (shown only if status is Comment) -->
                  <!-- <div class="row mb-3" *ngIf="multiForm.get(EC_Submission.23.status').value === 'Comment'">
                    <label for="comment" class="col-sm-2 col-form-label">Comment</label>
                    <div class="col-sm-3">
                      <textarea id="comment" formControlName="comment" type="text" class="form-control" ></textarea>
                      <div *ngIf="multiForm.get(EC_Submission.23.comment').invalid && multiForm.get(EC_Submission.23.comment').touched"
                        class="text-danger">
                        Please enter a valid comment.
                      </div>
                    </div>
                  </div> -->

                  <!-- Reason Dropdown (shown only if status is No) -->
                  <!-- <div class="row mb-3" *ngIf="multiForm.get(EC_Submission.23.status').value === 'No'">
                    <label for="reason" class="col-sm-2 col-form-label">Reason</label>
                    <div class="col-sm-3">
                      <select id="reason" formControlName="reason" class="form-select">
                        <option value="">Select Reason</option>
                      </select>
                      <div
                        *ngIf="multiForm.get(EC_Submission.23.reason').invalid && multiForm.get(EC_Submission.23.reason').touched"
                        class="text-danger">
                        Reason is required when status is No.
                      </div>
                    </div>
                  </div> -->

                  <!-- Signature Field -->
                  <!-- <div class="row mb-3" *ngIf="multiForm.get(EC_Submission.23.status').value === 'No'">
                    <label for="signature" class="col-sm-2 col-form-label">input</label>
                    <div class="col-sm-3">
                      <input id="signature" formControlName="input" type="text" class="form-control" />
                      <div *ngIf="multiForm.get(EC_Submission.23.input').invalid && multiForm.get(EC_Submission.23.input').touched"
                        class="text-danger">
                        Please enter a valid Link.
                      </div>
                    </div>
                  </div> -->
                  <div *ngIf="multiForm.get('EC_Submission.23.status').value === 'Approved'" class="mb-3 row">
                    <label [for]="control + '-date'" class="form-label col-sm-2">Date</label>
                    <div class="col-sm-2">
                      <input type="date" [id]="control + '-date'" formControlName="date" class="form-control" />
                    </div>
                  </div>
                  <!-- Dropdown for Queries Raised Status -->
                  <div *ngIf="multiForm.get('EC_Submission.23.status').value === 'Queries raised'" class="mb-3 row">
                    <label [for]="'reason'" class="form-label col-sm-2">Reason</label>
                    <div class="col-sm-3">
                      <select id="reason" formControlName="reason" class="form-select">
                      <option value="">Select Reason</option>
                      <option value="Raised Queries Received from IEC verbally ">Raised Queries Received from IEC verbally</option>
                      <option value="Raised Queries letter Received from IEC ">Raised Queries letter Received from IEC</option>
                      <option value="Query letter Received - response not provided by CRO/sponsors ">Query letter Received - response not provided by CRO/sponsors</option>
                      <option value="Raised Queries resolved from CRO/Sponsor reply not submitted by PI ">Raised Queries resolved from CRO/Sponsor reply not submitted by PI</option>
                      <option value="Raised Queries resolved - reply submitted to IEC ">Raised Queries resolved - reply submitted to IEC</option>
                      <option value="Other ">Other</option>
                    </select>
                  <div
                  *ngIf="multiForm.get('EC_Submission.23.reason').invalid && multiForm.get('EC_Submission.23.reason').touched"
                  class="text-danger">
                  Reason is required when status is Quaries raised
                </div>
                </div>
                </div>
                  
                  

              </div>
                
                <div formGroupName="25">
                  <!-- Status Dropdown -->
                  <h5>Was this study amended or not 1</h5>
                  <div>
                    <input type="radio" [id]="control + '-radio-yes'" formControlName="input" [value]="1" /> Yes
                    <input type="radio" [id]="control + '-radio-no'" formControlName="input" [value]="0" /> No
                  </div>
                  <!-- Date Picker for 'Yes' Selection -->
                  <div *ngIf="multiForm.get('EC_Submission.25.input').value === 1" class="mb-3 row">
                    <label for="control + '-radio-yes'" class="form-label col-sm-2">Date</label>
                    <div class="col-sm-3">
                      <input type="date" id="control + '-radio-yes'" formControlName="date" class="form-control" />
                    </div>
                  </div>
                </div>
                <div formGroupName="82">
                  <!-- Status Dropdown -->
                  <h5>Was this study amended or not 2</h5>
                  <div>
                    <input type="radio" [id]="control + '-radio-yes'" formControlName="input" [value]="1" /> Yes
                    <input type="radio" [id]="control + '-radio-no'" formControlName="input" [value]="0" /> No
                  </div>
                  <!-- Date Picker for 'Yes' Selection -->
                  <div *ngIf="multiForm.get('EC_Submission.82.input').value === 1" class="mb-3 row">
                    <label for="control + '-radio-yes'" class="form-label col-sm-2">Date</label>
                    <div class="col-sm-3">
                      <input type="date" id="control + '-radio-yes'" formControlName="date" class="form-control" />
                    </div>
                  </div>
                </div>
                <div formGroupName="83">
                  <!-- Status Dropdown -->
                  <h5>Was this study amended or not 3</h5>
                  <div>
                    <input type="radio" [id]="control + '-radio-yes'" formControlName="input" [value]="1" /> Yes
                    <input type="radio" [id]="control + '-radio-no'" formControlName="input" [value]="0" /> No
                  </div>
                  <!-- Date Picker for 'Yes' Selection -->
                  <div *ngIf="multiForm.get('EC_Submission.83.input').value === 1" class="mb-3 row">
                    <label for="control + '-radio-yes'" class="form-label col-sm-2">Date</label>
                    <div class="col-sm-3">
                      <input type="date" id="control + '-radio-yes'" formControlName="date" class="form-control" />
                    </div>
                  </div>
                </div>
                <div formGroupName="84">
                  <!-- Status Dropdown -->
                  <h5>Was this study amended or not 4</h5>
                  <div>
                    <input type="radio" [id]="control + '-radio-yes'" formControlName="input" [value]="1" /> Yes
                    <input type="radio" [id]="control + '-radio-no'" formControlName="input" [value]="0" /> No
                  </div>
                  <!-- Date Picker for 'Yes' Selection -->
                  <div *ngIf="multiForm.get('EC_Submission.84.input').value === 1" class="mb-3 row">
                    <label for="control + '-radio-yes'" class="form-label col-sm-2">Date</label>
                    <div class="col-sm-3">
                      <input type="date" id="control + '-radio-yes'" formControlName="date" class="form-control" />
                    </div>
                  </div>
                </div>
                <div formGroupName="85">
                  <!-- Status Dropdown -->
                  <h5>Was this study amended or not 5</h5>
                  <div>
                    <input type="radio" [id]="control + '-radio-yes'" formControlName="input" [value]="1" /> Yes
                    <input type="radio" [id]="control + '-radio-no'" formControlName="input" [value]="0" /> No
                  </div>
                  <!-- Date Picker for 'Yes' Selection -->
                  <div *ngIf="multiForm.get('EC_Submission.85.input').value === 1" class="mb-3 row">
                    <label for="control + '-radio-yes'" class="form-label col-sm-2">Date</label>
                    <div class="col-sm-3">
                      <input type="date" id="control + '-radio-yes'" formControlName="date" class="form-control" />
                    </div>
                  </div>
                </div>
                <div formGroupName="24">
                  <!-- Status Dropdown -->
                  <h5>Final Approval Received</h5>
                  <div class="mb-3">
                    <div>
                      <input type="radio" [id]="control + '-radio-yes'" formControlName="input" [value]="1" /> Yes
                      <input type="radio" [id]="control + '-radio-no'" formControlName="input" [value]="0" /> No
                    </div>
                  </div>
                  <!-- Date Picker for 'Yes' Selection -->
                  <div *ngIf="multiForm.get('EC_Submission.24.input').value === 1" class="mb-3 row">
                    <label for="control + '-radio-yes'" class="form-label col-sm-2">Date</label>
                    <div class="col-sm-3">
                      <input type="date" id="control + '-radio-yes'" formControlName="date" class="form-control" />
                    </div>
                  </div>

                  
                </div>
                <div class="row">
                  <div class="col-sm-3 offset-sm-2">
                    <button type="button" class="btn btn-primary" (click)="onSubmit()">Submit</button>
                  </div>
                </div>
              </div>
              <div *ngIf="currentFormIndex == 14" formGroupName="CTRI_Done">
                <div formGroupName="26">
                  <h5>CTRI DONE</h5>
                  <!-- Status Dropdown -->
                  <div class="row mb-3">
                    <label for="status" class="col-sm-2 col-form-label">Status</label>
                    <div class="col-sm-3">
                      <select id="status" formControlName="status" class="form-select">
                        <option value="">Select Status</option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                        <option value="NA">NA</option>
                        <option value="Comment">Others</option>
                      </select>
                      <div
                        *ngIf="multiForm.get('CTRI_Done.26.status').invalid && multiForm.get('CTRI_Done.26.status').touched"
                        class="text-danger">
                        Status is required.
                      </div>
                    </div>
                  </div>

                  <!-- Comment Field (shown only if status is Comment) -->
                  <div class="row mb-3" *ngIf="multiForm.get('CTRI_Done.26.status').value === 'Comment'">
                    <label for="comment" class="col-sm-2 col-form-label">Reason</label>
                    <div class="col-sm-3">
                      <textarea id="comment" formControlName="comment" type="text" class="form-control" ></textarea>
                      <div
                        *ngIf="multiForm.get('CTRI_Done.26.comment').invalid && multiForm.get('CTRI_Done.26.comment').touched"
                        class="text-danger">
                        Please enter a valid comment.
                      </div>
                    </div>
                  </div>

                  <!-- Reason Dropdown (shown only if status is No) -->
                  <div class="row mb-3" *ngIf="multiForm.get('CTRI_Done.26.status').value === 'No'">
                    <label for="reason" class="col-sm-2 col-form-label">Reason</label>
                    <div class="col-sm-3">
                      <select id="reason" formControlName="reason" class="form-select">
                        <option value="">Select Reason</option>
                        <option value="EC approval pending"> EC approval pending </option>
                        <option value="Incomplete details of the PI"> Incomplete details of the PI </option>
                        <option value="Trial verification not done"> Trial verification not done </option>
                        <option value="PI CTRI Reply is pending"> PI CTRI Reply is pending </option>
                        <option value="CTRI Raised Queries Pending"> CTRI Raised Queries Pending </option>
                        <option value="Other"> Other </option>
                      </select>
                      <div
                        *ngIf="multiForm.get('CTRI_Done.26.reason').invalid && multiForm.get('CTRI_Done.26.reason').touched"
                        class="text-danger">
                        Reason is required when status is No.
                      </div>
                    </div>
                  </div>
                </div>
                <!--<div formGroupName="27">
                  <!-- Status Dropdown --
                  <h5>Was this study amended or not</h5>
                  <div>
                    <input type="radio" [id]="control + '-radio-yes'" formControlName="input" [value]="1" /> Yes
                    <input type="radio" [id]="control + '-radio-no'" formControlName="input" [value]="0" /> No
                  </div>
                </div>-->
                <div class="row">
                  <div class="col-sm-3 offset-sm-2">
                    <button type="button" class="btn btn-primary" (click)="onSubmit()">Submit</button>
                  </div>
                </div>
              </div>
              <div *ngIf="currentFormIndex == 16" formGroupName="SITE_INITATION_VISIT_DONE">
                <div formGroupName="32">
                  <h5>SITE INITATION VISIT DONE</h5>
                  <!-- Status Dropdown -->
                  <div class="row mb-3">
                    <label for="status" class="col-sm-2 col-form-label">Status</label>
                    <div class="col-sm-3">
                      <select id="status" formControlName="status" class="form-select">
                        <option value="">Select Status</option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                        <option value="NA">NA</option>
                        <option value="Comment">Others</option>
                      </select>
                      <div
                        *ngIf="multiForm.get('SITE_INITATION_VISIT_DONE.32.status').invalid && multiForm.get('SITE_INITATION_VISIT_DONE.32.status').touched"
                        class="text-danger">
                        Status is required.
                      </div>
                    </div>
                  </div>

                  <!-- Comment Field (shown only if status is Comment) -->
                  <div class="row mb-3"
                    *ngIf="multiForm.get('SITE_INITATION_VISIT_DONE.32.status').value === 'Comment'">
                    <label for="comment" class="col-sm-2 col-form-label">Reason</label>
                    <div class="col-sm-3">
                      <textarea id="comment" formControlName="comment" type="text" class="form-control" ></textarea>
                      <div
                        *ngIf="multiForm.get('SITE_INITATION_VISIT_DONE.32.comment').invalid && multiForm.get('SITE_INITATION_VISIT_DONE.32.comment').touched"
                        class="text-danger">
                        Please enter a valid comment.
                      </div>
                    </div>
                  </div>

                  <!-- Reason Dropdown (shown only if status is No) -->
                  <div class="row mb-3" *ngIf="multiForm.get('SITE_INITATION_VISIT_DONE.32.status').value === 'No'">
                    <label for="reason" class="col-sm-2 col-form-label">Reason</label>
                    <div class="col-sm-3">
                      <select id="reason" formControlName="reason" class="form-select">
                        <option value="">Select Reason</option>
                        <option value="SIV not done due to IEC approval not received yet"> SIV not done due to IEC
                          approval not received yet </option>
                        <option value="Site initiation visit date not confirmed by PI"> Site initiation visit date not
                          confirmed by PI </option>
                        <option value="CRA postponed the visit"> CRA postponed the visit </option>
                        <option value="Site initiation visit is planned in following days"> Site initiation visit is
                          planned in following days </option>
                        <option value="Other"> Other </option>
                      </select>
                      <div
                        *ngIf="multiForm.get('SITE_INITATION_VISIT_DONE.32.reason').invalid && multiForm.get('SITE_INITATION_VISIT_DONE.32.reason').touched"
                        class="text-danger">
                        Reason is required when status is No.
                      </div>
                    </div>
                  </div>
                </div>
                <div formGroupName="33">
                  <h5>CTRI DONE</h5>
                  <!-- Status Dropdown -->
                  <div class="row mb-3">
                    <label for="status" class="col-sm-2 col-form-label">Status</label>
                    <div class="col-sm-3">
                      <select id="status" formControlName="status" class="form-select">
                        <option value="">Select Status</option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                        <option value="NA">NA</option>
                        <option value="Comment">Others</option>
                      </select>
                      <div
                        *ngIf="multiForm.get('SITE_INITATION_VISIT_DONE.33.status').invalid && multiForm.get('SITE_INITATION_VISIT_DONE.33.status').touched"
                        class="text-danger">
                        Status is required.
                      </div>
                    </div>
                  </div>

                  <!-- Comment Field (shown only if status is Comment) -->
                  <div class="row mb-3"
                    *ngIf="multiForm.get('SITE_INITATION_VISIT_DONE.33.status').value === 'Comment'">
                    <label for="comment" class="col-sm-2 col-form-label">Reason</label>
                    <div class="col-sm-3">
                      <textarea id="comment" formControlName="comment" type="text" class="form-control" ></textarea>
                      <div
                        *ngIf="multiForm.get('SITE_INITATION_VISIT_DONE.33.comment').invalid && multiForm.get('SITE_INITATION_VISIT_DONE.33.comment').touched"
                        class="text-danger">
                        Please enter a valid comment.
                      </div>
                    </div>
                  </div>

                  <!-- Reason Dropdown (shown only if status is No) -->
                  <div class="row mb-3" *ngIf="multiForm.get('SITE_INITATION_VISIT_DONE.33.status').value === 'No'">
                    <label for="reason" class="col-sm-2 col-form-label">Reason</label>
                    <div class="col-sm-3">
                      <select id="reason" formControlName="reason" class="form-select">
                        <option value="">Select Reason</option>
                        <option value="SIV visit not done"> SIV visit not done </option>
                      </select>
                      <div
                        *ngIf="multiForm.get('SITE_INITATION_VISIT_DONE.33.reason').invalid && multiForm.get('SITE_INITATION_VISIT_DONE.33.reason').touched"
                        class="text-danger">
                        Reason is required when status is No.
                      </div>
                    </div>
                  </div>
                </div>
                <div formGroupName="34">
                  <h5>CTRI DONE</h5>
                  <!-- Status Dropdown -->
                  <div class="row mb-3">
                    <label for="status" class="col-sm-2 col-form-label">Status</label>
                    <div class="col-sm-3">
                      <select id="status" formControlName="status" class="form-select">
                        <option value="">Select Status</option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                        <option value="NA">NA</option>
                        <option value="Comment">Others</option>
                      </select>
                      <div
                        *ngIf="multiForm.get('SITE_INITATION_VISIT_DONE.34.status').invalid && multiForm.get('SITE_INITATION_VISIT_DONE.34.status').touched"
                        class="text-danger">
                        Status is required.
                      </div>
                    </div>
                  </div>

                  <!-- Comment Field (shown only if status is Comment) -->
                  <div class="row mb-3"
                    *ngIf="multiForm.get('SITE_INITATION_VISIT_DONE.34.status').value === 'Comment'">
                    <label for="comment" class="col-sm-2 col-form-label">Reason</label>
                    <div class="col-sm-3">
                      <textarea id="comment" formControlName="comment" type="text" class="form-control" ></textarea>
                      <div
                        *ngIf="multiForm.get('SITE_INITATION_VISIT_DONE.34.comment').invalid && multiForm.get('SITE_INITATION_VISIT_DONE.34.comment').touched"
                        class="text-danger">
                        Please enter a valid comment.
                      </div>
                    </div>
                  </div>

                  <!-- Reason Dropdown (shown only if status is No) -->
                  <div class="row mb-3" *ngIf="multiForm.get('SITE_INITATION_VISIT_DONE.34.status').value === 'No'">
                    <label for="reason" class="col-sm-2 col-form-label">Reason</label>
                    <div class="col-sm-3">
                      <select id="reason" formControlName="reason" class="form-select">
                        <option value="">Select Reason</option>
                        <option value="SIV not done"> SIV not done </option>
                      </select>
                      <div
                        *ngIf="multiForm.get('SITE_INITATION_VISIT_DONE.34.reason').invalid && multiForm.get('SITE_INITATION_VISIT_DONE.34.reason').touched"
                        class="text-danger">
                        Reason is required when status is No.
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-3 offset-sm-2">
                    <button type="button" class="btn btn-primary" (click)="onSubmit()">Submit</button>
                  </div>
                </div>
              </div>
              <div *ngIf="currentFormIndex == 17" formGroupName="RUNNING_STATUS">
                <div formGroupName="42">
                  <h5>FIRST PATIENT SCREENING DONE</h5>
                  <!-- Status Dropdown -->
                  <div class="row mb-3">
                    <label for="status" class="col-sm-2 col-form-label">Status</label>
                    <div class="col-sm-3">
                      <select id="status" formControlName="status" class="form-select">
                        <option value="">Select Status</option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                        <option value="NA">NA</option>
                        <option value="Comment">Others</option>
                      </select>
                      <div
                        *ngIf="multiForm.get('RUNNING_STATUS.42.status').invalid && multiForm.get('RUNNING_STATUS.42.status').touched"
                        class="text-danger">
                        Status is required.
                      </div>
                    </div>
                  </div>

                  <!-- Comment Field (shown only if status is Comment) -->
                  <div class="row mb-3" *ngIf="multiForm.get('RUNNING_STATUS.42.status').value === 'Comment'">
                    <label for="comment" class="col-sm-2 col-form-label">Reason</label>
                    <div class="col-sm-3">
                      <textarea id="comment" formControlName="comment" type="text" class="form-control" ></textarea>
                      <div
                        *ngIf="multiForm.get('RUNNING_STATUS.42.comment').invalid && multiForm.get('RUNNING_STATUS.42.comment').touched"
                        class="text-danger">
                        Please enter a valid comment.
                      </div>
                    </div>
                  </div>

                  <!-- Reason Dropdown (shown only if status is No) -->
                  <div class="row mb-3" *ngIf="multiForm.get('RUNNING_STATUS.42.status').value === 'No'">
                    <label for="reason" class="col-sm-2 col-form-label">Reason</label>
                    <div class="col-sm-3">
                      <select id="reason" formControlName="reason" class="form-select">
                        <option value="">Select Reason</option>
                        <option value="Patient does not fulfill the eligibility criteria"> Patient does not fulfill the eligibility criteria </option>
                        <option value="Study IP not available"> Study IP not available</option>
                        <option value="ICF is not available in regional language"> ICF is not available in regional language </option>
                        <option value="Lab kit not available"> Lab kit not available </option>
                        <option value="Not getting subject at site according to protocol"> Not getting subject at site according to protocol </option>
                        <option value="Study documents not available"> Study documents not available </option>
                        <option value="Site staff not available"> Site staff not available </option>
                        <option value="Site initiation visit not done"> Site initiation visit not done </option>
                        <option value="EC approval pending"> EC approval pending </option>
                        <option value="Study device not available"> Study device not available </option>
                    
                        <option value="Other"> Other </option>
                      </select>
                      <div
                        *ngIf="multiForm.get('RUNNING_STATUS.42.reason').invalid && multiForm.get('RUNNING_STATUS.42.reason').touched"
                        class="text-danger">
                        Reason is required when status is No.
                      </div>
                    </div>
                  </div>
                </div>
                <div formGroupName="91">
                  <h5>Total Sample Size</h5>
                  <div class="row mb-3">
                    <label for="signature" class="col-sm-2 col-form-label"
                      >input</label
                    >
                    <div class="col-sm-3">
                      <input
                        id="signature"
                        formControlName="input"
                        type="text"
                        class="form-control"
                      />
                      <div
                        *ngIf="
                          multiForm.get('RUNNING_STATUS.91.input').invalid &&
                          multiForm.get('RUNNING_STATUS.91.input').touched
                        "
                        class="text-danger"
                      >
                        Please enter a valid Link.
                      </div>
                    </div>
                  </div>
                </div>
                <div formGroupName="68">
                  <h5>Total no of subjects screened</h5>
                  <div class="row mb-3">
                    <label for="signature" class="col-sm-2 col-form-label">input</label>
                    <div class="col-sm-3">
                      <input id="signature" formControlName="input" type="text" class="form-control" />
                      <div
                        *ngIf="multiForm.get('RUNNING_STATUS.68.input').invalid && multiForm.get('RUNNING_STATUS.68.input').touched"
                        class="text-danger">
                        Please enter a valid Link.
                      </div>
                    </div>
                  </div>
                </div>
                <div formGroupName="69">
                  <h5>Total no of Subject randomized/enrolled in study</h5>
                  <div class="row mb-3">
                    <label for="signature" class="col-sm-2 col-form-label">input</label>
                    <div class="col-sm-3">
                      <input id="signature" formControlName="input" type="text" class="form-control" />
                      <div
                        *ngIf="multiForm.get('RUNNING_STATUS.69.input').invalid && multiForm.get('RUNNING_STATUS.69.input').touched"
                        class="text-danger">
                        Please enter a valid Link.
                      </div>
                    </div>
                  </div>
                </div>
                <div formGroupName="86">
                  <h5>Total no of Subjects Ongoing</h5>
                  <div class="row mb-3">
                    <label for="signature" class="col-sm-2 col-form-label">input</label>
                    <div class="col-sm-3">
                      <input id="signature" formControlName="input" type="text" class="form-control" />
                      <div
                        *ngIf="multiForm.get('RUNNING_STATUS.86.input').invalid && multiForm.get('RUNNING_STATUS.69.input').touched"
                        class="text-danger">
                        Please enter a valid Link.
                      </div>
                    </div>
                  </div>
                </div>
                <div formGroupName="70">
                  <h5>Total no of Screen failure subject</h5>
                  <div class="row mb-3">
                    <label for="signature" class="col-sm-2 col-form-label">input</label>
                    <div class="col-sm-3">
                      <input id="signature" formControlName="input" type="text" class="form-control" />
                      <div
                        *ngIf="multiForm.get('RUNNING_STATUS.70.input').invalid && multiForm.get('RUNNING_STATUS.70.input').touched"
                        class="text-danger">
                        Please enter a valid Link.
                      </div>
                    </div>
                  </div>
                </div>
                <div formGroupName="71">
                  <h5>Total no of Subject dropped out</h5>
                  <div class="row mb-3">
                    <label for="signature" class="col-sm-2 col-form-label">input</label>
                    <div class="col-sm-3">
                      <input id="signature" formControlName="input" type="text" class="form-control" />
                      <div
                        *ngIf="multiForm.get('RUNNING_STATUS.71.input').invalid && multiForm.get('RUNNING_STATUS.71.input').touched"
                        class="text-danger">
                        Please enter a valid Link.
                      </div>
                    </div>
                  </div>
                </div>
                <div formGroupName="72">
                  <h5>Total no of subject completed</h5>
                  <div class="row mb-3">
                    <label for="signature" class="col-sm-2 col-form-label">input</label>
                    <div class="col-sm-3">
                      <input id="signature" formControlName="input" type="text" class="form-control" />
                      <div
                        *ngIf="multiForm.get('RUNNING_STATUS.72.input').invalid && multiForm.get('RUNNING_STATUS.72.input').touched"
                        class="text-danger">
                        Please enter a valid Link.
                      </div>
                    </div>
                  </div>
                </div>
                <div formGroupName="73">
                  <h5>Total no of subject compliance with IP</h5>
                  <div class="row mb-3">
                    <label for="signature" class="col-sm-2 col-form-label">input</label>
                    <div class="col-sm-3">
                      <input id="signature" formControlName="input" type="text" class="form-control" />
                      <div
                        *ngIf="multiForm.get('RUNNING_STATUS.73.input').invalid && multiForm.get('RUNNING_STATUS.73.input').touched"
                        class="text-danger">
                        Please enter a valid Link.
                      </div>
                    </div>
                  </div>
                </div>
                <div formGroupName="74">
                  <h5>Total no of SAE(serious adverse events)</h5>
                  <div>
                    <input type="radio" [id]="control + '-radio-yes'" formControlName="input" [value]="1" /> Yes
                    <input type="radio" [id]="control + '-radio-no'" formControlName="input" [value]="0" /> No
                  </div>
                  <!-- <div class="row mb-3">
                    <label for="signature" class="col-sm-2 col-form-label">input</label>
                    <div class="col-sm-3">
                      <input id="signature" formControlName="input" type="text" class="form-control" />
                      <div *ngIf="multiForm.get('RUNNING_STATUS.74.input').invalid && multiForm.get('RUNNING_STATUS.74.input').touched"
                        class="text-danger">
                        Please enter a valid Link.
                      </div>
                    </div>
                  </div> -->
                  <div class="m-3" formGroupName="sub_data" *ngIf="multiForm.get('RUNNING_STATUS.74.input').value == 1">
                    <div class="row mb-3">
                      <h5>Enter no of SAE</h5>
                      <label for="signature" class="col-sm-2 col-form-label">input</label>
                      <div class="col-sm-3">
                        <input id="signature" formControlName="input_7" type="text" class="form-control" />
                        <div
                          *ngIf="multiForm.get('RUNNING_STATUS.74.input').invalid && multiForm.get('RUNNING_STATUS.74.input').touched"
                          class="text-danger">
                          Please enter a valid Link.
                        </div>
                      </div>
                  </div>
                    
                    <div class="row mb-3">
                      <h5>SAE Reporting done to IEC (Y/N)</h5>
                      <div>
                        <input type="radio" [id]="control + '-radio-yes'" formControlName="input_1" [value]="1" /> Yes
                        <input type="radio" [id]="control + '-radio-no'" formControlName="input_1" [value]="0" /> No
                      </div>
                    </div>
                    <div class="row mb-3">
                      <h5>SAE Reporting done to CRO(Y/N)</h5>
                      <div>
                        <input type="radio" [id]="control + '-radio-yes'" formControlName="input_2" [value]="1" /> Yes
                        <input type="radio" [id]="control + '-radio-no'" formControlName="input_2" [value]="0" /> No
                      </div>
                    </div>
                    <div class="row mb-3">
                      <h5>SAE Initial repot submited to CRO and IEC (Y/N)</h5>
                      <div>
                        <input type="radio" [id]="control + '-radio-yes'" formControlName="input_3" [value]="1" /> Yes
                        <input type="radio" [id]="control + '-radio-no'" formControlName="input_3" [value]="0" /> No
                      </div>
                    </div>
                  </div>
                  <div class="m-3" formGroupName="sub_data" *ngIf="multiForm.get('RUNNING_STATUS.74.input').value == 0">
                    <!-- <h5>Protocol deviation done</h5> -->
                    <div class="row mb-3">
                      <label for="signature" class="col-sm-2 col-form-label">input</label>
                      <div class="col-sm-3">
                        <input id="signature" formControlName="input_4" type="text" class="form-control" />
                        <div
                          *ngIf="multiForm.get('RUNNING_STATUS.74.input').invalid && multiForm.get('RUNNING_STATUS.74.input').touched"
                          class="text-danger">
                          Please enter a valid Link.
                        </div>
                      </div>
                    </div>
                    
                  </div>
                </div>
                <div formGroupName="89">
                  <h5>Adverse Event</h5>
                  <div class="row mb-3">
                    <label for="signature" class="col-sm-2 col-form-label">input</label>
                    <div class="col-sm-3">
                      <input id="signature" formControlName="input" type="text" class="form-control" />
                      <div
                        *ngIf="multiForm.get('RUNNING_STATUS.89.input').invalid && multiForm.get('RUNNING_STATUS.89.input').touched"
                        class="text-danger">
                        Please enter a valid Link.
                      </div>
                    </div>
                  </div>
                </div>
                <div formGroupName="90">
                  <h5>Adverse Drug Reaction</h5>
                  <div class="row mb-3">
                    <label for="signature" class="col-sm-2 col-form-label">input</label>
                    <div class="col-sm-3">
                      <input id="signature" formControlName="input" type="text" class="form-control" />
                      <div
                        *ngIf="multiForm.get('RUNNING_STATUS.90.input').invalid && multiForm.get('RUNNING_STATUS.90.input').touched"
                        class="text-danger">
                        Please enter a valid Link.
                      </div>
                    </div>
                  </div>
                </div>
                <div formGroupName="92">
                  <h5>Protocol Number</h5>
                  <div class="row mb-3">
                    <label for="signature" class="col-sm-2 col-form-label"
                      >input</label
                    >
                    <div class="col-sm-3">
                      <input
                        id="signature"
                        formControlName="input"
                        type="text"
                        class="form-control"
                      />
                      <div
                        *ngIf="
                          multiForm.get('RUNNING_STATUS.92.input').invalid &&
                          multiForm.get('RUNNING_STATUS.92.input').touched
                        "
                        class="text-danger"
                      >
                        Please enter a valid Link.
                      </div>
                    </div>
                  </div>
                </div>
                <div formGroupName="75">
                  <h5> Protocol deviation done</h5>
                  <div>
                    <input type="radio" [id]="control + '-radio-yes'" formControlName="input" [value]="1" /> Yes
                    <input type="radio" [id]="control + '-radio-no'" formControlName="input" [value]="0" /> No
                  </div>
                  <div class="m-3" formGroupName="sub_data" *ngIf="multiForm.get('RUNNING_STATUS.75.input').value == 1">
                    <!-- <h5>Protocol deviation done</h5> -->
                    <div class="row mb-3">
                      <label for="status" class="col-sm-2 col-form-label">Status</label>
                      <div class="col-sm-3">
                        <select id="status" formControlName="input_1" class="form-select">
                          <option value="">Select Status</option>
                          <option value="Protocol deviation Recorded">Protocol deviation Recorded</option>
                          <option value="Protocol deviation notify to IEC">Protocol deviation notify to IEC </option>
                        </select>
                        <!-- <div *ngIf="multiForm.get('RUNNING_STATUS.75.input_1').invalid && multiForm.get('RUNNING_STATUS.75.input_1').touched"
                            class="text-danger">
                            Status is required.
                          </div> -->
                      </div>
                    </div>
                  </div>
                  <div class="m-3" formGroupName="sub_data" *ngIf="multiForm.get('RUNNING_STATUS.75.input').value == 0">
                    <!-- <h5>Protocol deviation done</h5> -->
                    <div class="row mb-3">
                      <label for="signature" class="col-sm-2 col-form-label">input</label>
                      <div class="col-sm-3">
                        <input id="signature" formControlName="input_1" type="text" class="form-control" />
                        <div
                          *ngIf="multiForm.get('RUNNING_STATUS.75.input').invalid && multiForm.get('RUNNING_STATUS.75.input').touched"
                          class="text-danger">
                          Please enter a valid Link.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-3 offset-sm-2">
                    <button type="button" class="btn btn-primary" (click)="onSubmit()">Submit</button>
                  </div>
                </div>
              </div>
              <div *ngIf="currentFormIndex == 18" formGroupName="Data_Entry">
                <div formGroupName="36">
                  <h5>DATA ENRTY SHEET COMPLETION</h5>
                  <!-- Status Dropdown -->
                  <div class="row mb-3">
                    <label for="status" class="col-sm-2 col-form-label">Status</label>
                    <div class="col-sm-3">
                      <select id="status" formControlName="status" class="form-select">
                        <option value="">Select Status</option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                        <option value="NA">NA</option>
                        <option value="Comment">Others</option>
                      </select>
                      <div
                        *ngIf="multiForm.get('Data_Entry.36.status').invalid && multiForm.get('Data_Entry.36.status').touched"
                        class="text-danger">
                        Status is required.
                      </div>
                    </div>
                  </div>

                  <!-- Comment Field (shown only if status is Comment) -->
                  <div class="row mb-3" *ngIf="multiForm.get('Data_Entry.36.status').value === 'Comment'">
                    <label for="comment" class="col-sm-2 col-form-label">Reason</label>
                    <div class="col-sm-3">
                      <textarea id="comment" formControlName="comment" type="text" class="form-control" ></textarea>
                      <div
                        *ngIf="multiForm.get('Data_Entry.36.comment').invalid && multiForm.get('Data_Entry.36.comment').touched"
                        class="text-danger">
                        Please enter a valid comment.
                      </div>
                    </div>
                  </div>

                  <!-- Reason Dropdown (shown only if status is No) -->
                  <div class="row mb-3" *ngIf="multiForm.get('Data_Entry.36.status').value === 'No'">
                    <label for="reason" class="col-sm-2 col-form-label">Reason</label>
                    <div class="col-sm-3">
                      <select id="reason" formControlName="reason" class="form-select">
                        <option value="">Select Reason</option>
                        <option value="Query resolution pending"> Query resolution pending </option>
                        <option value="Incomplete data"> Incomplete data </option>
                        <option value="PI signature not present in the CRF"> PI signature not present in the CRF
                        </option>
                        <option value="Follow-up visit of the subject pending"> Follow-up visit of the subject pending
                        </option>
                        <option value="Site staff not available"> Site staff not available </option>
                        <option value="Incorrect data entry is done"> Incorrect data entry is done </option>
                        <option value="Incomplete CRF"> Incomplete CRF </option>
                        <option value="Incomplete source documentation"> Incomplete source documentation </option>
                        <option value="Other"> Other </option>
                      </select>
                      <div
                        *ngIf="multiForm.get('Data_Entry.36.reason').invalid && multiForm.get('Data_Entry.36.reason').touched"
                        class="text-danger">
                        Reason is required when status is No.
                      </div>
                    </div>
                  </div>
                </div>
                <div formGroupName="44">
                  <h5>Data entry sheet query resolution done</h5>
                  <!-- Status Dropdown -->
                  <div class="row mb-3">
                    <label for="status" class="col-sm-2 col-form-label">Status</label>
                    <div class="col-sm-3">
                      <select id="status" formControlName="status" class="form-select">
                        <option value="">Select Status</option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                        <option value="NA">NA</option>
                        <option value="Comment">Others</option>
                      </select>
                      <div
                        *ngIf="multiForm.get('Data_Entry.44.status').invalid && multiForm.get('Data_Entry.44.status').touched"
                        class="text-danger">
                        Status is required.
                      </div>
                    </div>
                  </div>

                  <!-- Comment Field (shown only if status is Comment) -->
                  <div class="row mb-3" *ngIf="multiForm.get('Data_Entry.44.status').value === 'Comment'">
                    <label for="comment" class="col-sm-2 col-form-label">Reason</label>
                    <div class="col-sm-3">
                      <textarea id="comment" formControlName="comment" type="text" class="form-control" ></textarea>
                      <div
                        *ngIf="multiForm.get('Data_Entry.44.comment').invalid && multiForm.get('Data_Entry.44.comment').touched"
                        class="text-danger">
                        Please enter a valid comment.
                      </div>
                    </div>
                  </div>

                  <!-- Reason Dropdown (shown only if status is No) -->
                  <div class="row mb-3" *ngIf="multiForm.get('Data_Entry.44.status').value === 'No'">
                    <label for="reason" class="col-sm-2 col-form-label">Reason</label>
                    <div class="col-sm-3">
                      <select id="reason" formControlName="reason" class="form-select">
                        <option value="">Select Reason</option>
                        <option value="Query resolution pending"> Query resolution pending </option>
                        <option value="Incomplete data"> Incomplete data </option>
                        <option value="PI signature not present in the CRF"> PI signature not present in the CRF
                        </option>
                        <option value="Follow-up visit of the subject pending"> Follow-up visit of the subject pending
                        </option>
                        <option value="Site staff not available"> Site staff not available </option>
                        <option value="Incorrect data entry is done"> Incorrect data entry is done </option>
                        <option value="Incomplete CRF"> Incomplete CRF </option>
                        <option value="Incomplete source documentation"> Incomplete source documentation </option>
                        <option value="Other"> Other </option>
                      </select>
                      <div
                        *ngIf="multiForm.get('Data_Entry.44.reason').invalid && multiForm.get('Data_Entry.44.reason').touched"
                        class="text-danger">
                        Reason is required when status is No.
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-3 offset-sm-2">
                    <button type="button" class="btn btn-primary" (click)="onSubmit()">Submit</button>
                  </div>
                </div>
              </div>
              <div *ngIf="currentFormIndex == 19" formGroupName="CSR_Sumbission">
                <div formGroupName="37">
                  <h5>CSR SUBMITTED TO PI</h5>
                  <!-- Status Dropdown -->
                  <div class="row mb-3">
                    <label for="status" class="col-sm-2 col-form-label">Status</label>
                    <div class="col-sm-3">
                      <select id="status" formControlName="status" class="form-select">
                        <option value="">Select Status</option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                        <option value="NA">NA</option>
                        <option value="Comment">Others</option>
                      </select>
                      <div
                        *ngIf="multiForm.get('CSR_Sumbission.37.status').invalid && multiForm.get('CSR_Sumbission.37.status').touched"
                        class="text-danger">
                        Status is required.
                      </div>
                    </div>
                  </div>

                  <!-- Comment Field (shown only if status is Comment) -->
                  <div class="row mb-3" *ngIf="multiForm.get('CSR_Sumbission.37.status').value === 'Comment'">
                    <label for="comment" class="col-sm-2 col-form-label">Reason</label>
                    <div class="col-sm-3">
                      <textarea id="comment" formControlName="comment" type="text" class="form-control" ></textarea>
                      <div
                        *ngIf="multiForm.get('CSR_Sumbission.37.comment').invalid && multiForm.get('CSR_Sumbission.37.comment').touched"
                        class="text-danger">
                        Please enter a valid comment.
                      </div>
                    </div>
                  </div>

                  <!-- Reason Dropdown (shown only if status is No) -->
                  <div class="row mb-3" *ngIf="multiForm.get('CSR_Sumbission.37.status').value === 'No'">
                    <label for="reason" class="col-sm-2 col-form-label">Reason</label>
                    <div class="col-sm-3">
                      <select id="reason" formControlName="reason" class="form-select">
                        <option value="">Select Reason</option>
                        <option value="Data analysis pending"> Data analysis pending </option>
                        <option value="Signature page not signed by the PI"> Signature page not signed by the PI
                        </option>
                        <option value="Signature page not signed by the CRO/Sponsor"> Signature page not signed by the
                          CRO/Sponsor </option>
                        <option value="CRO/Sponsor has not finalized the CSR"> CRO/Sponsor has not finalized the CSR
                        </option>
                        <option value="CRO/Sponsor has not sent CSR"> CRO/Sponsor has not sent CSR </option>
                        <option value="Site information not mentioned"> Site information not mentioned </option>
                        <option value="EC details not mentioned"> EC details not mentioned </option>
                        <option value="CSR not submitted to the EC by site staff"> CSR not submitted to the EC by site
                          staff </option>
                        <option value="Other"> Other </option>
                      </select>
                      <div
                        *ngIf="multiForm.get('CSR_Sumbission.37.reason').invalid && multiForm.get('CSR_Sumbission.37.reason').touched"
                        class="text-danger">
                        Reason is required when status is No.
                      </div>
                    </div>
                  </div>
                </div>
                <div formGroupName="38">
                  <h5>Final CSR submitted to the EC</h5>
                  <div class="mb-3">
                    <div>
                      <input type="radio" [id]="control + '-radio-yes'" formControlName="input" [value]="1" /> Yes
                      <input type="radio" [id]="control + '-radio-no'" formControlName="input" [value]="0" /> No
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-3 offset-sm-2">
                    <button type="button" class="btn btn-primary" (click)="onSubmit()">Submit</button>
                  </div>
                </div>
              </div>
              <div *ngIf="currentFormIndex == 40" formGroupName="Subject_Identity_Submission">
                <div formGroupName="41">
                  <h5>Add Subjects</h5>
                  <div class="row mb-3">
                    <label for="signature" class="col-sm-2 col-form-label">input</label>
                    <div class="col-sm-3">
                      <input id="signature" formControlName="input" type="text" class="form-control" />
                      <div
                        *ngIf="multiForm.get('Subject_Identity_Submission.41.input').invalid && multiForm.get('Subject_Identity_Submission.41.input').touched"
                        class="text-danger">
                        Please enter a valid Link.
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-3 offset-sm-2">
                    <button type="button" class="btn btn-primary" (click)="onSubmit()">Submit</button>
                  </div>
                </div>
              </div>
              <div *ngIf="currentFormIndex == 20" formGroupName="Close_Out">
                <div formGroupName="39">
                  <h5>CLOSE OUT VISIT</h5>
                  <!-- Status Dropdown -->
                  <div class="row mb-3">
                    <label for="status" class="col-sm-2 col-form-label">Status</label>
                    <div class="col-sm-3">
                      <select id="status" formControlName="status" class="form-select">
                        <option value="">Select Status</option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                        <option value="NA">NA</option>
                        <option value="Comment">Others</option>
                      </select>
                      <div
                        *ngIf="multiForm.get('Close_Out.39.status').invalid && multiForm.get('Close_Out.39.status').touched"
                        class="text-danger">
                        Status is required.
                      </div>
                    </div>
                  </div>

                  <!-- Comment Field (shown only if status is Comment) -->
                  <div class="row mb-3" *ngIf="multiForm.get('Close_Out.39.status').value === 'Comment'">
                    <label for="comment" class="col-sm-2 col-form-label">Reason</label>
                    <div class="col-sm-3">
                      <textarea id="comment" formControlName="comment" type="text" class="form-control" ></textarea>
                      <div
                        *ngIf="multiForm.get('Close_Out.39.comment').invalid && multiForm.get('Close_Out.39.comment').touched"
                        class="text-danger">
                        Please enter a valid comment.
                      </div>
                    </div>
                  </div>

                  <!-- Reason Dropdown (shown only if status is No) -->
                  <div class="row mb-3" *ngIf="multiForm.get('Close_Out.39.status').value === 'No'">
                    <label for="reason" class="col-sm-2 col-form-label">Reason</label>
                    <div class="col-sm-3">
                      <select id="reason" formControlName="reason" class="form-select">
                        <option value="">Select Reason</option>
                        <option value="Document is missing"> Document is missing </option>
                        <option value="CRF is incomplete"> CRF is incomplete </option>
                        <option value="EC Fees pending"> EC Fees pending </option>
                        <option value="Archival fees pending"> Archival fees pending </option>
                        <option value="The query resolution is pending"> The query resolution is pending </option>
                        <option value="CRO/Sponsor postponed the visit"> CRO/Sponsor postponed the visit </option>
                        <option value="Data entry pending"> Data entry pending </option>
                        <option value="CSR Submission pending"> CSR Submission pending </option>
                        <option value="IP Reconciliation Not done"> IP Reconciliation Not done </option>
                        <option value="Logs not Completed"> Logs not Completed </option>
                        <option value="TMF is incomplete"> TMF is incomplete </option>
                        <option value="SAE Documentation incomplete"> SAE Documentation incomplete </option>
                        <option value="Query from CRO Pending"> Query from CRO Pending </option>
                        <option value="Pre Close out visit pending"> Pre Close out visit pending </option>
                        <option value="PI invoice pending"> PI invoice pending </option>
                        <option value="Drug Accountability not done"> Drug Accountability not done </option>
                        <option value="Drug Destruction not done"> Drug Destruction not done </option>
                        <option value="Delegation log missing"> Delegation log missing </option>
                        <option value="Other"> Other </option>
                      </select>
                      <div
                        *ngIf="multiForm.get('Close_Out.39.reason').invalid && multiForm.get('Close_Out.39.reason').touched"
                        class="text-danger">
                        Reason is required when status is No.
                      </div>
                    </div>
                  </div>
                </div>
                <div formGroupName="76">
                  <h5>Documents archival done</h5>
                  <div class="mb-3">
                    <div>
                      <input type="radio" [id]="control + '-radio-yes'" formControlName="input" [value]="1" /> Yes
                      <input type="radio" [id]="control + '-radio-no'" formControlName="input" [value]="0" /> No
                    </div>
                  </div>
                </div>
                <div formGroupName="77">
                  <h5>IP disposition done and documented</h5>
                  <div class="mb-3">
                    <div>
                      <input type="radio" [id]="control + '-radio-yes'" formControlName="input" [value]="1" /> Yes
                      <input type="radio" [id]="control + '-radio-no'" formControlName="input" [value]="0" /> No
                    </div>
                  </div>
                </div>
                <div formGroupName="78">
                  <h5>Non IP disposition done and documented</h5>
                  <div class="mb-3">
                    <div>
                      <input type="radio" [id]="control + '-radio-yes'" formControlName="input" [value]="1" /> Yes
                      <input type="radio" [id]="control + '-radio-no'" formControlName="input" [value]="0" /> No
                    </div>
                  </div>
                </div>
                <div formGroupName="79">
                  <h5>Final Payment Budget remunration Done</h5>
                  <div class="mb-3">
                    <div>
                      <input type="radio" [id]="control + '-radio-yes'" formControlName="input" [value]="1" /> Yes
                      <input type="radio" [id]="control + '-radio-no'" formControlName="input" [value]="0" /> No
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-3 offset-sm-2">
                    <button type="button" class="btn btn-primary" (click)="onSubmit()">Submit</button>
                  </div>
                </div>
              </div>
              <div *ngIf="currentFormIndex == 88" formGroupName="publication">
                <div formGroupName="87">
                  <h5>Publication Status</h5>
                  
                  <!-- Status Dropdown -->
                  <div class="row mb-3">
                    <label for="publicationStatus" class="col-sm-2 col-form-label">Status</label>
                    <div class="col-sm-3">
                      <select id="publicationStatus" formControlName="status" class="form-select">
                        <option value="">Select Status</option>
                        <option value="Submitted">Submitted</option>
                        <option value="Under Review">Under Review</option>
                        <option value="Rejected">Rejected</option>
                        <option value="Published">Published</option>
                      </select>
                      <div
                        *ngIf="multiForm.get('publication.87.status').invalid && multiForm.get('publication.87.status').touched"
                        class="text-danger">
                        Status is required.
                      </div>
                    </div>
                  </div>
              
                  <!-- Comment Field (shown only if status is Rejected) -->
                  <div class="row mb-3" *ngIf="multiForm.get('publication.87.status').value === 'Rejected'">
                    <label for="publicationComment" class="col-sm-2 col-form-label">Reason</label>
                    <div class="col-sm-3">
                      <textarea id="publicationComment" formControlName="comment" type="text" class="form-control"></textarea>
                      <div
                        *ngIf="multiForm.get('publication.87.comment').invalid && multiForm.get('publication.87.comment').touched"
                        class="text-danger">
                        Please enter a valid comment.
                      </div>
                    </div>
                  </div>
                </div>
              
                <!-- Submit Button -->
                <div class="row">
                  <div class="col-sm-3 offset-sm-2">
                    <button type="button" class="btn btn-primary" (click)="onSubmit()">Submit</button>
                  </div>
                </div>
              </div>
              
              <div *ngIf="currentFormIndex == 45" formGroupName="CTRI_Updation">
                <div formGroupName="80">
                  <h5>CTRI Updation</h5>
                  <!-- Status Dropdown -->
                  <div class="row mb-3">
                    <label for="status" class="col-sm-2 col-form-label">Status</label>
                    <div class="col-sm-3">
                      <select id="status" formControlName="status" class="form-select">
                        <option value="">Select Status</option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                        <option value="NA">NA</option>
                        <option value="Comment">Others/option>
                      </select>
                      <div
                        *ngIf="multiForm.get('CTRI_Updation.80.status').invalid && multiForm.get('CTRI_Updation.80.status').touched"
                        class="text-danger">
                        Status is required.
                      </div>
                    </div>
                  </div>

                  <!-- Comment Field (shown only if status is Comment) -->
                  <div class="row mb-3" *ngIf="multiForm.get('CTRI_Updation.80.status').value === 'Comment'">
                    <label for="comment" class="col-sm-2 col-form-label">Reason</label>
                    <div class="col-sm-3">
                      <textarea id="comment" formControlName="comment" type="text" class="form-control" ></textarea>
                      <div
                        *ngIf="multiForm.get('CTRI_Updation.80.comment').invalid && multiForm.get('CTRI_Updation.80.comment').touched"
                        class="text-danger">
                        Please enter a valid comment.
                      </div>
                    </div>
                  </div>

                  <!-- Reason Dropdown (shown only if status is No) -->
                  <div class="row mb-3" *ngIf="multiForm.get('CTRI_Updation.80.status').value === 'No'">
                    <label for="reason" class="col-sm-2 col-form-label">Reason</label>
                    <div class="col-sm-3">
                      <select id="reason" formControlName="reason" class="form-select">
                        <option value="">Select Reason</option>
                        <option value="Study Completion not Done"> Study Completion not Done </option>
                        <option value="Study CSR Submission not Done"> Study CSR Submission not Done </option>
                        <option value="Further Details need to be updated"> Further Details need to be updated </option>
                        <option value="Other"> Other </option>
                      </select>
                      <div
                        *ngIf="multiForm.get('CTRI_Updation.80.reason').invalid && multiForm.get('CTRI_Updation.80.reason').touched"
                        class="text-danger">
                        Reason is required when status is No.
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-3 offset-sm-2">
                    <button type="button" class="btn btn-primary" (click)="onSubmit()">Submit</button>
                  </div>
                </div>
              </div>
              <div *ngIf="currentFormIndex == 15" formGroupName="IP_NONIP">
                <div formGroupName="28">
                  <h5>IP</h5>
                  <!-- Status Dropdown -->
                  <div class="row mb-3">
                    <label for="status" class="col-sm-2 col-form-label">IP Receieved</label>
                    <div class="col-sm-3">
                      <select id="status" formControlName="status" class="form-select">
                        <option value="">Select Status</option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                        <option value="NA">NA</option>
                        <option value="Comment">Others</option>
                      </select>
                      <div
                        *ngIf="multiForm.get('IP_NONIP.28.status').invalid && multiForm.get('IP_NONIP.28.status').touched"
                        class="text-danger">
                        Status is required.
                      </div>
                    </div>
                  </div>

                  <!-- Comment Field (shown only if status is Comment) -->
                  <div class="row mb-3" *ngIf="multiForm.get('IP_NONIP.28.status').value === 'Comment'">
                    <label for="comment" class="col-sm-2 col-form-label">Reason</label>
                    <div class="col-sm-3">
                      <textarea id="comment" formControlName="comment" type="text" class="form-control" ></textarea>
                      <div
                        *ngIf="multiForm.get('IP_NONIP.28.comment').invalid && multiForm.get('IP_NONIP.28.comment').touched"
                        class="text-danger">
                        Please enter a valid comment.
                      </div>
                    </div>
                  </div>

                  <!-- Reason Dropdown (shown only if status is No) -->
                  <div class="row mb-3" *ngIf="multiForm.get('IP_NONIP.28.status').value === 'No'">
                    <label for="reason" class="col-sm-2 col-form-label">Reason</label>
                    <div class="col-sm-3">
                      <select id="reason" formControlName="reason" class="form-select">
                        <option value="">Select Reason</option>
                        <option value="Delayed in transit"> Delayed in transit </option>
                        <option value="Not sent by CRO/Sponsor"> Not sent by CRO/Sponsor </option>
                        <option value="Responsible person was not available on site to receive IP"> Responsible person was not available on site to receive IP </option>
                        <option value="IP delivered to wrong address"> IP delivered to wrong address </option>
                        <option value="Damaged IP received at site"> Damaged IP received at site </option>
                        <option value="Other"> Other </option>
                      </select>
                      <div
                        *ngIf="multiForm.get('IP_NONIP.28.reason').invalid && multiForm.get('IP_NONIP.28.reason').touched"
                        class="text-danger">
                        Reason is required when status is No.
                      </div>
                    </div>
                  </div>
                </div>
                <div formGroupName="29">
                  <h5>IP CODE 1</h5>
                  <div class="row mb-3">
                    <label for="signature" class="col-sm-2 col-form-label">IP code</label>
                    <div class="col-sm-3">
                      <input id="signature" formControlName="input" type="text" class="form-control" />
                      <div
                        *ngIf="multiForm.get('IP_NONIP.29.input').invalid && multiForm.get('IP_NONIP.29.input').touched"
                        class="text-danger">
                        Please enter a valid Link.
                      </div>
                    </div>
                  </div>
                  <div class="mb-3 row">
                    <label [for]="control + '-date'" class="form-label col-sm-2">Date</label>
                    <div class="col-sm-2">
                      <input type="date" [id]="control + '-date'" formControlName="date" class="form-control" />
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label for="quantity" class="col-sm-2 col-form-label">Quantity</label>
                    <div class="col-sm-3">
                      <input id="quantity" formControlName="quantity" type="text" class="form-control" />
                      <div
                        *ngIf="multiForm.get('IP_NONIP.29.quantity').invalid && multiForm.get('IP_NONIP.29.quantity').touched"
                        class="text-danger">
                        Please enter a valid Link.
                      </div>
                    </div>
                  </div>
                </div>
                <div formGroupName="64">
                  <h5>IP CODE 2</h5>
                  <div class="row mb-3">
                    <label for="signature" class="col-sm-2 col-form-label">IP code</label>
                    <div class="col-sm-3">
                      <input id="signature" formControlName="input" type="text" class="form-control" />
                      <div
                        *ngIf="multiForm.get('IP_NONIP.64.input').invalid && multiForm.get('IP_NONIP.64.input').touched"
                        class="text-danger">
                        Please enter a valid Link.
                      </div>
                    </div>
                  </div>
                  <div class="mb-3 row">
                    <label [for]="control + '-date'" class="form-label col-sm-2">Date</label>
                    <div class="col-sm-2">
                      <input type="date" [id]="control + '-date'" formControlName="date" class="form-control" />
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label for="quantity" class="col-sm-2 col-form-label">Quantity</label>
                    <div class="col-sm-3">
                      <input id="quantity" formControlName="quantity" type="text" class="form-control" />
                      <div
                        *ngIf="multiForm.get('IP_NONIP.64.quantity').invalid && multiForm.get('IP_NONIP.64.quantity').touched"
                        class="text-danger">
                        Please enter a valid Link.
                      </div>
                    </div>
                  </div>
                </div>
                <div formGroupName="65">
                  <h5>IP CODE 3</h5>
                  <div class="row mb-3">
                    <label for="signature" class="col-sm-2 col-form-label">IP code</label>
                    <div class="col-sm-3">
                      <input id="signature" formControlName="input" type="text" class="form-control" />
                      <div
                        *ngIf="multiForm.get('IP_NONIP.65.input').invalid && multiForm.get('IP_NONIP.65.input').touched"
                        class="text-danger">
                        Please enter a valid Link.
                      </div>
                    </div>
                  </div>
                  <div class="mb-3 row">
                    <label [for]="control + '-date'" class="form-label col-sm-2">Date</label>
                    <div class="col-sm-2">
                      <input type="date" [id]="control + '-date'" formControlName="date" class="form-control" />
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label for="quantity" class="col-sm-2 col-form-label">Quantity</label>
                    <div class="col-sm-3">
                      <input id="quantity" formControlName="quantity" type="text" class="form-control" />
                      <div
                        *ngIf="multiForm.get('IP_NONIP.65.quantity').invalid && multiForm.get('IP_NONIP.65.quantity').touched"
                        class="text-danger">
                        Please enter a valid Link.
                      </div>
                    </div>
                  </div>
                </div>
                <div formGroupName="66">
                  <h5>IP CODE 4</h5>
                  <div class="row mb-3">
                    <label for="signature" class="col-sm-2 col-form-label">IP code</label>
                    <div class="col-sm-3">
                      <input id="signature" formControlName="input" type="text" class="form-control" />
                      <div
                        *ngIf="multiForm.get('IP_NONIP.66.input').invalid && multiForm.get('IP_NONIP.66.input').touched"
                        class="text-danger">
                        Please enter a valid Link.
                      </div>
                    </div>
                  </div>
                  <div class="mb-3 row">
                    <label [for]="control + '-date'" class="form-label col-sm-2">Date</label>
                    <div class="col-sm-2">
                      <input type="date" [id]="control + '-date'" formControlName="date" class="form-control" />
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label for="quantity" class="col-sm-2 col-form-label">Quantity</label>
                    <div class="col-sm-3">
                      <input id="quantity" formControlName="quantity" type="text" class="form-control" />
                      <div
                        *ngIf="multiForm.get('IP_NONIP.66.quantity').invalid && multiForm.get('IP_NONIP.66.quantity').touched"
                        class="text-danger">
                        Please enter a valid Link.
                      </div>
                    </div>
                  </div>
                </div>
                <div formGroupName="67">
                  <h5>IP CODE 5</h5>
                  <div class="row mb-3">
                    <label for="signature" class="col-sm-2 col-form-label">IP code</label>
                    <div class="col-sm-3">
                      <input id="signature" formControlName="input" type="text" class="form-control" />
                      <div
                        *ngIf="multiForm.get('IP_NONIP.67.input').invalid && multiForm.get('IP_NONIP.67.input').touched"
                        class="text-danger">
                        Please enter a valid Link.
                      </div>
                    </div>
                  </div>
                  <div class="mb-3 row">
                    <label [for]="control + '-date'" class="form-label col-sm-2">Date</label>
                    <div class="col-sm-2">
                      <input type="date" [id]="control + '-date'" formControlName="date" class="form-control" />
                    </div>
                  </div>
                  <div class="row mb-3">
                    <label for="quantity" class="col-sm-2 col-form-label">Quantity</label>
                    <div class="col-sm-3">
                      <input id="quantity" formControlName="quantity" type="text" class="form-control" />
                      <div
                        *ngIf="multiForm.get('IP_NONIP.67.quantity').invalid && multiForm.get('IP_NONIP.67.quantity').touched"
                        class="text-danger">
                        Please enter a valid Link.
                      </div>
                    </div>
                  </div>
                </div>
                <div formGroupName="51">
                  <h5>Total IP Require at site according to sample size Recived</h5>
                  <div class="row mb-3">
                    <label for="input" class="col-sm-2 col-form-label">Input</label>
                    <div class="col-sm-3">
                      <input id="input" formControlName="input" type="text" class="form-control" />
                      <div
                        *ngIf="multiForm.get('IP_NONIP.51.input').invalid && multiForm.get('IP_NONIP.51.input').touched"
                        class="text-danger">
                        Please enter a valid Input.
                      </div>
                    </div>
                  </div>
                </div>
                <div formGroupName="52">
                  <h5>Total IP RECEIVED</h5>
                  <div class="row mb-3">
                    <label for="input" class="col-sm-2 col-form-label">Input</label>
                    <div class="col-sm-3">
                      <input id="input" formControlName="input" type="text" class="form-control" />
                      <div
                        *ngIf="multiForm.get('IP_NONIP.52.input').invalid && multiForm.get('IP_NONIP.52.input').touched"
                        class="text-danger">
                        Please enter a valid Input.
                      </div>
                    </div>
                  </div>
                </div>
                <div formGroupName="53">
                  <h5>IP used till date</h5>
                  <div class="row mb-3">
                    <label for="input" class="col-sm-2 col-form-label">Input</label>
                    <div class="col-sm-3">
                      <input id="input" formControlName="input" type="text" class="form-control" />
                      <div
                        *ngIf="multiForm.get('IP_NONIP.53.input').invalid && multiForm.get('IP_NONIP.53.input').touched"
                        class="text-danger">
                        Please enter a valid Input.
                      </div>
                    </div>
                  </div>
                </div>
                <div formGroupName="54">
                  <h5>IP Stock</h5>
                  <div class="row mb-3">
                    <label for="input" class="col-sm-2 col-form-label">Input</label>
                    <div class="col-sm-3">
                      <input id="input" formControlName="input" type="text" class="form-control" />
                      <div
                        *ngIf="multiForm.get('IP_NONIP.54.input').invalid && multiForm.get('IP_NONIP.54.input').touched"
                        class="text-danger">
                        Please enter a valid Input.
                      </div>
                    </div>
                  </div>
                </div>
                <div formGroupName="55">
                  <h5>IP returned / destroyed</h5>
                  <div class="row mb-3">
                    <label for="status" class="col-sm-2 col-form-label">Status</label>
                    <div class="col-sm-3">
                      <select id="status" formControlName="status" class="form-select">
                        <option value="">Select Status</option>
                        <option value="Yes">Returned</option>
                        <option value="No">Destroyed</option>
                      </select>
                      <div
                        *ngIf="multiForm.get('IP_NONIP.55.status').invalid && multiForm.get('IP_NONIP.55.status').touched"
                        class="text-danger">
                        Status is required.
                      </div>
                    </div>
                  </div>
                </div>
                <div formGroupName="56">
                  <h5>NON-IP</h5>
                  <!-- Status Dropdown -->
                  <div class="row mb-3">
                    <label for="status" class="col-sm-2 col-form-label">Status</label>
                    <div class="col-sm-3">
                      <select id="status" formControlName="status" class="form-select">
                        <option value="">Select Status</option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                        <option value="NA">NA</option>
                        <option value="Comment">Others</option>
                      </select>
                      <div
                        *ngIf="multiForm.get('IP_NONIP.56.status').invalid && multiForm.get('IP_NONIP.56.status').touched"
                        class="text-danger">
                        Status is required.
                      </div>
                    </div>
                  </div>

                  <!-- Comment Field (shown only if status is Comment) -->
                  <div class="row mb-3" *ngIf="multiForm.get('IP_NONIP.56.status').value === 'Comment'">
                    <label for="comment" class="col-sm-2 col-form-label">Reason</label>
                    <div class="col-sm-3">
                      <textarea id="comment" formControlName="comment" type="text" class="form-control" ></textarea>
                      <div
                        *ngIf="multiForm.get('IP_NONIP.56.comment').invalid && multiForm.get('IP_NONIP.56.comment').touched"
                        class="text-danger">
                        Please enter a valid comment.
                      </div>
                    </div>
                  </div>

                  <!-- Reason Dropdown (shown only if status is No) -->
                  <div class="row mb-3" *ngIf="multiForm.get('IP_NONIP.56.status').value === 'No'">
                    <label for="reason" class="col-sm-2 col-form-label">Reason</label>
                    <div class="col-sm-3">
                      <select id="reason" formControlName="reason" class="form-select">
                        <option value="">Select Reason</option>
                        <option value="Study Completion not Done"> Study Completion not Done </option>
                        <option value="Study CSR Submission not Done"> Study CSR Submission not Done </option>
                        <option value="Further Details need to be updated"> Further Details need to be updated </option>
                        <option value="Other"> Other </option>
                      </select>
                      <div
                        *ngIf="multiForm.get('IP_NONIP.56.reason').invalid && multiForm.get('IP_NONIP.56.reason').touched"
                        class="text-danger">
                        Reason is required when status is No.
                      </div>
                    </div>
                  </div>
                </div>
                <div formGroupName="57">
                  <h5>ICD</h5>
                  <!-- Status Dropdown -->
                  <div class="row mb-3">
                    <label for="status" class="col-sm-2 col-form-label">Status</label>
                    <div class="col-sm-3">
                      <select id="status" formControlName="status" class="form-select">
                        <option value="">Select Status</option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                        <option value="NA">NA</option>
                        <option value="Comment">Others</option>
                      </select>
                      <div
                        *ngIf="multiForm.get('IP_NONIP.57.status').invalid && multiForm.get('IP_NONIP.57.status').touched"
                        class="text-danger">
                        Status is required.
                      </div>
                    </div>
                  </div>

                  <!-- Comment Field (shown only if status is Comment) -->
                  <div class="row mb-3" *ngIf="multiForm.get('IP_NONIP.57.status').value === 'Comment'">
                    <label for="comment" class="col-sm-2 col-form-label">Reason</label>
                    <div class="col-sm-3">
                      <textarea id="comment" formControlName="comment" type="text" class="form-control" ></textarea>
                      <div
                        *ngIf="multiForm.get('IP_NONIP.57.comment').invalid && multiForm.get('IP_NONIP.57.comment').touched"
                        class="text-danger">
                        Please enter a valid comment.
                      </div>
                    </div>
                  </div>

                  <!-- Reason Dropdown (shown only if status is No) -->
                  <div class="row mb-3" *ngIf="multiForm.get('IP_NONIP.57.status').value === 'No'">
                    <label for="reason" class="col-sm-2 col-form-label">Reason</label>
                    <div class="col-sm-3">
                      <select id="reason" formControlName="reason" class="form-select">
                        <option value="">Select Reason</option>
                        <option value="Study Completion not Done"> Study Completion not Done </option>
                        <option value="Study CSR Submission not Done"> Study CSR Submission not Done </option>
                        <option value="Further Details need to be updated"> Further Details need to be updated </option>
                        <option value="Other"> Other </option>
                      </select>
                      <div
                        *ngIf="multiForm.get('IP_NONIP.57.reason').invalid && multiForm.get('IP_NONIP.57.reason').touched"
                        class="text-danger">
                        Reason is required when status is No.
                      </div>
                    </div>
                  </div>
                </div>
                <div formGroupName="58">
                  <h5>CRF</h5>
                  <!-- Status Dropdown -->
                  <div class="row mb-3">
                    <label for="status" class="col-sm-2 col-form-label">Status</label>
                    <div class="col-sm-3">
                      <select id="status" formControlName="status" class="form-select">
                        <option value="">Select Status</option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                        <option value="NA">NA</option>
                        <option value="Comment">Others</option>
                      </select>
                      <div
                        *ngIf="multiForm.get('IP_NONIP.58.status').invalid && multiForm.get('IP_NONIP.58.status').touched"
                        class="text-danger">
                        Status is required.
                      </div>
                    </div>
                  </div>

                  <!-- Comment Field (shown only if status is Comment) -->
                  <div class="row mb-3" *ngIf="multiForm.get('IP_NONIP.58.status').value === 'Comment'">
                    <label for="comment" class="col-sm-2 col-form-label">Reason</label>
                    <div class="col-sm-3">
                      <textarea id="comment" formControlName="comment" type="text" class="form-control" ></textarea>
                      <div
                        *ngIf="multiForm.get('IP_NONIP.58.comment').invalid && multiForm.get('IP_NONIP.58.comment').touched"
                        class="text-danger">
                        Please enter a valid comment.
                      </div>
                    </div>
                  </div>

                  <!-- Reason Dropdown (shown only if status is No) -->
                  <div class="row mb-3" *ngIf="multiForm.get('IP_NONIP.58.status').value === 'No'">
                    <label for="reason" class="col-sm-2 col-form-label">Reason</label>
                    <div class="col-sm-3">
                      <select id="reason" formControlName="reason" class="form-select">
                        <option value="">Select Reason</option>
                        <option value="Study Completion not Done"> Study Completion not Done </option>
                        <option value="Study CSR Submission not Done"> Study CSR Submission not Done </option>
                        <option value="Further Details need to be updated"> Further Details need to be updated </option>
                        <option value="Other"> Other </option>
                      </select>
                      <div
                        *ngIf="multiForm.get('IP_NONIP.58.reason').invalid && multiForm.get('IP_NONIP.58.reason').touched"
                        class="text-danger">
                        Reason is required when status is No.
                      </div>
                    </div>
                  </div>
                </div>
                <div formGroupName="59">
                  <h5>DIARY</h5>
                  <!-- Status Dropdown -->
                  <div class="row mb-3">
                    <label for="status" class="col-sm-2 col-form-label">Status</label>
                    <div class="col-sm-3">
                      <select id="status" formControlName="status" class="form-select">
                        <option value="">Select Status</option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                        <option value="NA">NA</option>
                        <option value="Comment">Others</option>
                      </select>
                      <div
                        *ngIf="multiForm.get('IP_NONIP.59.status').invalid && multiForm.get('IP_NONIP.59.status').touched"
                        class="text-danger">
                        Status is required.
                      </div>
                    </div>
                  </div>

                  <!-- Comment Field (shown only if status is Comment) -->
                  <div class="row mb-3" *ngIf="multiForm.get('IP_NONIP.59.status').value === 'Comment'">
                    <label for="comment" class="col-sm-2 col-form-label">Reason</label>
                    <div class="col-sm-3">
                      <textarea id="comment" formControlName="comment" type="text" class="form-control" ></textarea>
                      <div
                        *ngIf="multiForm.get('IP_NONIP.59.comment').invalid && multiForm.get('IP_NONIP.59.comment').touched"
                        class="text-danger">
                        Please enter a valid comment.
                      </div>
                    </div>
                  </div>

                  <!-- Reason Dropdown (shown only if status is No) -->
                  <div class="row mb-3" *ngIf="multiForm.get('IP_NONIP.59.status').value === 'No'">
                    <label for="reason" class="col-sm-2 col-form-label">Reason</label>
                    <div class="col-sm-3">
                      <select id="reason" formControlName="reason" class="form-select">
                        <option value="">Select Reason</option>
                        <option value="Study Completion not Done"> Study Completion not Done </option>
                        <option value="Study CSR Submission not Done"> Study CSR Submission not Done </option>
                        <option value="Further Details need to be updated"> Further Details need to be updated </option>
                        <option value="Other"> Other </option>
                      </select>
                      <div
                        *ngIf="multiForm.get('IP_NONIP.59.reason').invalid && multiForm.get('IP_NONIP.59.reason').touched"
                        class="text-danger">
                        Reason is required when status is No.
                      </div>
                    </div>
                  </div>
                </div>
                <div formGroupName="60">
                  <h5>SD</h5>
                  <!-- Status Dropdown -->
                  <div class="row mb-3">
                    <label for="status" class="col-sm-2 col-form-label">Status</label>
                    <div class="col-sm-3">
                      <select id="status" formControlName="status" class="form-select">
                        <option value="">Select Status</option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                        <option value="NA">NA</option>
                        <option value="Comment">Others</option>
                      </select>
                      <div
                        *ngIf="multiForm.get('IP_NONIP.60.status').invalid && multiForm.get('IP_NONIP.60.status').touched"
                        class="text-danger">
                        Status is required.
                      </div>
                    </div>
                  </div>

                  <!-- Comment Field (shown only if status is Comment) -->
                  <div class="row mb-3" *ngIf="multiForm.get('IP_NONIP.60.status').value === 'Comment'">
                    <label for="comment" class="col-sm-2 col-form-label">Reason</label>
                    <div class="col-sm-3">
                      <textarea id="comment" formControlName="comment" type="text" class="form-control" ></textarea>
                      <div
                        *ngIf="multiForm.get('IP_NONIP.60.comment').invalid && multiForm.get('IP_NONIP.60.comment').touched"
                        class="text-danger">
                        Please enter a valid comment.
                      </div>
                    </div>
                  </div>

                  <!-- Reason Dropdown (shown only if status is No) -->
                  <div class="row mb-3" *ngIf="multiForm.get('IP_NONIP.60.status').value === 'No'">
                    <label for="reason" class="col-sm-2 col-form-label">Reason</label>
                    <div class="col-sm-3">
                      <select id="reason" formControlName="reason" class="form-select">
                        <option value="">Select Reason</option>
                        <option value="Study Completion not Done"> Study Completion not Done </option>
                        <option value="Study CSR Submission not Done"> Study CSR Submission not Done </option>
                        <option value="Further Details need to be updated"> Further Details need to be updated </option>
                        <option value="Other"> Other </option>
                      </select>
                      <div
                        *ngIf="multiForm.get('IP_NONIP.60.reason').invalid && multiForm.get('IP_NONIP.60.reason').touched"
                        class="text-danger">
                        Reason is required when status is No.
                      </div>
                    </div>
                  </div>
                </div>
                <div formGroupName="61">
                  <h5>ICP</h5>
                  <!-- Status Dropdown -->
                  <div class="row mb-3">
                    <label for="status" class="col-sm-2 col-form-label">Status</label>
                    <div class="col-sm-3">
                      <select id="status" formControlName="status" class="form-select">
                        <option value="">Select Status</option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                        <option value="NA">NA</option>
                        <option value="Comment">Others</option>
                      </select>
                      <div
                        *ngIf="multiForm.get('IP_NONIP.61.status').invalid && multiForm.get('IP_NONIP.61.status').touched"
                        class="text-danger">
                        Status is required.
                      </div>
                    </div>
                  </div>

                  <!-- Comment Field (shown only if status is Comment) -->
                  <div class="row mb-3" *ngIf="multiForm.get('IP_NONIP.61.status').value === 'Comment'">
                    <label for="comment" class="col-sm-2 col-form-label">Reason</label>
                    <div class="col-sm-3">
                      <textarea id="comment" formControlName="comment" type="text" class="form-control" ></textarea>
                      <div
                        *ngIf="multiForm.get('IP_NONIP.61.comment').invalid && multiForm.get('IP_NONIP.61.comment').touched"
                        class="text-danger">
                        Please enter a valid comment.
                      </div>
                    </div>
                  </div>

                  <!-- Reason Dropdown (shown only if status is No) -->
                  <div class="row mb-3" *ngIf="multiForm.get('IP_NONIP.61.status').value === 'No'">
                    <label for="reason" class="col-sm-2 col-form-label">Reason</label>
                    <div class="col-sm-3">
                      <select id="reason" formControlName="reason" class="form-select">
                        <option value="">Select Reason</option>
                        <option value="Study Completion not Done"> Study Completion not Done </option>
                        <option value="Study CSR Submission not Done"> Study CSR Submission not Done </option>
                        <option value="Further Details need to be updated"> Further Details need to be updated </option>
                        <option value="Other"> Other </option>
                      </select>
                      <div
                        *ngIf="multiForm.get('IP_NONIP.61.reason').invalid && multiForm.get('IP_NONIP.61.reason').touched"
                        class="text-danger">
                        Reason is required when status is No.
                      </div>
                    </div>
                  </div>
                </div>
                <div formGroupName="62">
                  <h5>SAE FORM</h5>
                  <!-- Status Dropdown -->
                  <div class="row mb-3">
                    <label for="status" class="col-sm-2 col-form-label">Status</label>
                    <div class="col-sm-3">
                      <select id="status" formControlName="status" class="form-select">
                        <option value="">Select Status</option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                        <option value="NA">NA</option>
                        <option value="Comment">Others</option>
                      </select>
                      <div
                        *ngIf="multiForm.get('IP_NONIP.62.status').invalid && multiForm.get('IP_NONIP.62.status').touched"
                        class="text-danger">
                        Status is required.
                      </div>
                    </div>
                  </div>

                  <!-- Comment Field (shown only if status is Comment) -->
                  <div class="row mb-3" *ngIf="multiForm.get('IP_NONIP.62.status').value === 'Comment'">
                    <label for="comment" class="col-sm-2 col-form-label">Reason</label>
                    <div class="col-sm-3">
                      <textarea id="comment" formControlName="comment" type="text" class="form-control" ></textarea>
                      <div
                        *ngIf="multiForm.get('IP_NONIP.62.comment').invalid && multiForm.get('IP_NONIP.62.comment').touched"
                        class="text-danger">
                        Please enter a valid comment.
                      </div>
                    </div>
                  </div>

                  <!-- Reason Dropdown (shown only if status is No) -->
                  <div class="row mb-3" *ngIf="multiForm.get('IP_NONIP.62.status').value === 'No'">
                    <label for="reason" class="col-sm-2 col-form-label">Reason</label>
                    <div class="col-sm-3">
                      <select id="reason" formControlName="reason" class="form-select">
                        <option value="">Select Reason</option>
                        <option value="Study Completion not Done"> Study Completion not Done </option>
                        <option value="Study CSR Submission not Done"> Study CSR Submission not Done </option>
                        <option value="Further Details need to be updated"> Further Details need to be updated </option>
                        <option value="Other"> Other </option>
                      </select>
                      <div
                        *ngIf="multiForm.get('IP_NONIP.62.reason').invalid && multiForm.get('IP_NONIP.62.reason').touched"
                        class="text-danger">
                        Reason is required when status is No.
                      </div>
                    </div>
                  </div>
                </div>
                <div formGroupName="43">
                  <h5>study related equipments</h5>
                  <!-- Status Dropdown -->
                  <div class="row mb-3">
                    <label for="status" class="col-sm-2 col-form-label">Status</label>
                    <div class="col-sm-3">
                      <ng-multiselect-dropdown formControlName="status"
                        [settings]="dropdownSettings" [data]="relatedEquipment" placeholder="Select Related Equipment">
                      </ng-multiselect-dropdown>
                      <div
                        *ngIf="multiForm.get('IP_NONIP.43.status').invalid && multiForm.get('IP_NONIP.43.status').touched"
                        class="text-danger">
                        Status is required.
                      </div>
                    </div>
                  </div>
                </div>
                <div formGroupName="30">
                  <h5>LAB KITS</h5>
                  <!-- Status Dropdown -->
                  <div class="row mb-3">
                    <label for="status" class="col-sm-2 col-form-label">Status</label>
                    <div class="col-sm-3">
                      <select id="status" formControlName="status" class="form-select">
                        <option value="">Select Status</option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                        <option value="NA">NA</option>
                        <option value="Comment">Others</option>
                      </select>
                      <div
                        *ngIf="multiForm.get('IP_NONIP.30.status').invalid && multiForm.get('IP_NONIP.30.status').touched"
                        class="text-danger">
                        Status is required.
                      </div>
                    </div>
                  </div>

                  <!-- Comment Field (shown only if status is Comment) -->
                  <div class="row mb-3" *ngIf="multiForm.get('IP_NONIP.30.status').value === 'Comment'">
                    <label for="comment" class="col-sm-2 col-form-label">Reason</label>
                    <div class="col-sm-3">
                      <textarea id="comment" formControlName="comment" type="text" class="form-control" ></textarea>
                      <div
                        *ngIf="multiForm.get('IP_NONIP.30.comment').invalid && multiForm.get('IP_NONIP.30.comment').touched"
                        class="text-danger">
                        Please enter a valid comment.
                      </div>
                    </div>
                  </div>

                  <!-- Reason Dropdown (shown only if status is No) -->
                  <div class="row mb-3" *ngIf="multiForm.get('IP_NONIP.30.status').value === 'No'">
                    <label for="reason" class="col-sm-2 col-form-label">Reason</label>
                    <div class="col-sm-3">
                      <select id="reason" formControlName="reason" class="form-select">
                        <option value="">Select Reason</option>
                        <option value="Responsible person not available on site"> Responsible person not available on site </option>
                        <option value="Courier service delayed"> Courier service delayed </option>
                        <option value="Site staff was on holiday"> Site staff was on holiday </option>
                        <option value="Kits not sent by lab"> Kits not sent by lab </option>
                        <option value="Wrong kits sent by lab"> Wrong kits sent by lab </option>
                        <option value="Incomplete set of kits sent by lab"> Incomplete set of kits sent by lab </option>
                        <option value="Damaged kits received by the site"> Damaged kits received by the site </option>
                        <option value="Other"> Other </option>
                      </select>
                      <div
                        *ngIf="multiForm.get('IP_NONIP.30.reason').invalid && multiForm.get('IP_NONIP.30.reason').touched"
                        class="text-danger">
                        Reason is required when status is No.
                      </div>
                    </div>
                  </div>
                </div>
                <div formGroupName="31">
                  <h5>TRF</h5>
                  <!-- Status Dropdown -->
                  <div class="row mb-3">
                    <label for="status" class="col-sm-2 col-form-label">Status</label>
                    <div class="col-sm-3">
                      <select id="status" formControlName="status" class="form-select">
                        <option value="">Select Status</option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                        <option value="NA">NA</option>
                        <option value="Comment">Others</option>
                      </select>
                      <div
                        *ngIf="multiForm.get('IP_NONIP.31.status').invalid && multiForm.get('IP_NONIP.31.status').touched"
                        class="text-danger">
                        Status is required.
                      </div>
                    </div>
                  </div>

                  <!-- Comment Field (shown only if status is Comment) -->
                  <div class="row mb-3" *ngIf="multiForm.get('IP_NONIP.31.status').value === 'Comment'">
                    <label for="comment" class="col-sm-2 col-form-label">Reason</label>
                    <div class="col-sm-3">
                      <textarea id="comment" formControlName="comment" type="text" class="form-control" ></textarea>
                      <div
                        *ngIf="multiForm.get('IP_NONIP.31.comment').invalid && multiForm.get('IP_NONIP.31.comment').touched"
                        class="text-danger">
                        Please enter a valid comment.
                      </div>
                    </div>
                  </div>

                  <!-- Reason Dropdown (shown only if status is No) -->
                  <div class="row mb-3" *ngIf="multiForm.get('IP_NONIP.31.status').value === 'No'">
                    <label for="reason" class="col-sm-2 col-form-label">Reason</label>
                    <div class="col-sm-3">
                      <select id="reason" formControlName="reason" class="form-select">
                        <option value="">Select Reason</option>
                        <option value="TRF not sent by lab"> TRF not sent by lab </option>
                        <option value="Incorrect details on TRF"> Incorrect details on TRF </option>
                        <option value="Missing details on TRF"> Missing details on TRF </option>
                        <option value="Missing test name"> Missing test name </option>
                        <option value="Other"> Other </option>
                      </select>
                      <div
                        *ngIf="multiForm.get('IP_NONIP.31.reason').invalid && multiForm.get('IP_NONIP.31.reason').touched"
                        class="text-danger">
                        Reason is required when status is No.
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-3 offset-sm-2">
                    <button type="button" class="btn btn-primary" (click)="onSubmit()">Submit</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>